//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AboutService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<AboutModel> {
        let url_ = this.baseUrl + "/api/About/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AboutModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AboutModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AboutModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AboutModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranslationByLanguage(): Observable<AboutTranslationModel> {
        let url_ = this.baseUrl + "/api/About/GetTranslationByLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AboutTranslationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AboutTranslationModel>;
        }));
    }

    protected processGetTranslationByLanguage(response: HttpResponseBase): Observable<AboutTranslationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AboutTranslationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveAboutModel | undefined): Observable<AboutModel> {
        let url_ = this.baseUrl + "/api/About/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AboutModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AboutModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<AboutModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AboutModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    authenticate(model: AuthenticateModel | undefined): Observable<AuthenticationModel | null> {
        let url_ = this.baseUrl + "/api/Authentication/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticationModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticationModel | null>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticationModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthenticationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshToken(request: RefreshAuthenticationModel | undefined): Observable<AuthenticationModel | null> {
        let url_ = this.baseUrl + "/api/Authentication/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticationModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticationModel | null>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<AuthenticationModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthenticationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BlogCategoryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string): Observable<BlogCategoryModel | null> {
        let url_ = this.baseUrl + "/api/BlogCategory/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlogCategoryModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlogCategoryModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BlogCategoryModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BlogCategoryModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBlogCategoryModel | undefined): Observable<BlogCategoryModel | null> {
        let url_ = this.baseUrl + "/api/BlogCategory/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlogCategoryModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlogCategoryModel | null>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<BlogCategoryModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BlogCategoryModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paged(model: BlogCategoryFilterPagingModel | undefined): Observable<PagedListModelOfBlogCategoryListModel | null> {
        let url_ = this.baseUrl + "/api/BlogCategory/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBlogCategoryListModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBlogCategoryListModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBlogCategoryListModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBlogCategoryListModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: SearchBlogCategoryModel | undefined): Observable<SearchBlogCategoryResultModel[] | null> {
        let url_ = this.baseUrl + "/api/BlogCategory/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchBlogCategoryResultModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchBlogCategoryResultModel[] | null>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchBlogCategoryResultModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchBlogCategoryResultModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfBlogCategoryFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BlogCategory/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivate(id: string, deactivate: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BlogCategory/Deactivate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deactivate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BlogService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string): Observable<BlogModel | null> {
        let url_ = this.baseUrl + "/api/Blog/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlogModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlogModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BlogModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BlogModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBlogModel | undefined): Observable<BlogModel | null> {
        let url_ = this.baseUrl + "/api/Blog/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlogModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlogModel | null>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<BlogModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BlogModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paged(model: BlogFilterPagingModel | undefined): Observable<PagedListModelOfBlogListModel | null> {
        let url_ = this.baseUrl + "/api/Blog/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBlogListModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBlogListModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBlogListModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBlogListModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfBlogFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blog/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivate(id: string, deactivate: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Blog/Deactivate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deactivate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clone(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/Blog/Clone?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BlogTagService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string): Observable<BlogTagModel | null> {
        let url_ = this.baseUrl + "/api/BlogTag/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlogTagModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlogTagModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BlogTagModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BlogTagModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBlogTagModel | undefined): Observable<BlogTagModel | null> {
        let url_ = this.baseUrl + "/api/BlogTag/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlogTagModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlogTagModel | null>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<BlogTagModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BlogTagModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paged(model: BlogTagFilterPagingModel | undefined): Observable<PagedListModelOfBlogTagListModel | null> {
        let url_ = this.baseUrl + "/api/BlogTag/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBlogTagListModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBlogTagListModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBlogTagListModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBlogTagListModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: SearchBlogTagModel | undefined): Observable<SearchBlogTagResultModel[] | null> {
        let url_ = this.baseUrl + "/api/BlogTag/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchBlogTagResultModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchBlogTagResultModel[] | null>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchBlogTagResultModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchBlogTagResultModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfBlogTagFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BlogTag/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivate(id: string, deactivate: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BlogTag/Deactivate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deactivate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessModelCanvasCommentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    paged(businessModelCanvasId: string, model: FilterPagingModel | undefined): Observable<PagedListModelOfBusinessModelCanvasCommentGridModel | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasComment/Paged?";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBusinessModelCanvasCommentGridModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBusinessModelCanvasCommentGridModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBusinessModelCanvasCommentGridModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBusinessModelCanvasCommentGridModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(businessModelCanvasId: string): Observable<BusinessModelCanvasCommentModel[] | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasComment/GetAll?";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasCommentModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasCommentModel[] | null>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BusinessModelCanvasCommentModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasCommentModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBusinessModelCanvasCommentModel | undefined, canvasSubject: BusinessModelCanvasSubject): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasComment/Save?";
        if (canvasSubject === undefined || canvasSubject === null)
            throw new Error("The parameter 'canvasSubject' must be defined and cannot be null.");
        else
            url_ += "canvasSubject=" + encodeURIComponent("" + canvasSubject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(businessModelCanvasId: string, id: string): Observable<BusinessModelCanvasCommentModel | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasComment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasCommentModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasCommentModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessModelCanvasCommentModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasCommentModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(businessModelCanvasId: string, id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasComment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    mention(businessModelCanvasId: string, businessModelCanvasCommentId: string, mentionedUsers: BusinessModelCanvasShareUserModel[] | undefined, canvasSubjectName: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasComment/Mention/{businessModelCanvasId}?";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined.");
        url_ = url_.replace("{businessModelCanvasId}", encodeURIComponent("" + businessModelCanvasId));
        if (businessModelCanvasCommentId === undefined || businessModelCanvasCommentId === null)
            throw new Error("The parameter 'businessModelCanvasCommentId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasCommentId=" + encodeURIComponent("" + businessModelCanvasCommentId) + "&";
        if (canvasSubjectName === undefined || canvasSubjectName === null)
            throw new Error("The parameter 'canvasSubjectName' must be defined and cannot be null.");
        else
            url_ += "canvasSubjectName=" + encodeURIComponent("" + canvasSubjectName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mentionedUsers);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMention(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMention(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processMention(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessModelCanvasService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    paged(model: BusinessModelCanvasFilterPagingModel | undefined): Observable<PagedListModelOfBusinessModelCanvasListModel | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvas/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBusinessModelCanvasListModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBusinessModelCanvasListModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBusinessModelCanvasListModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBusinessModelCanvasListModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfBusinessModelCanvasFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvas/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBusinessModelCanvasModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvas/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: string): Observable<BusinessModelCanvasModel | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessModelCanvasModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clone(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvas/Clone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    savePdf(id: string, fileModel: SaveFileModel | undefined, disableCancellationToken: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvas/SavePdf?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (disableCancellationToken === null)
            throw new Error("The parameter 'disableCancellationToken' cannot be null.");
        else if (disableCancellationToken !== undefined)
            url_ += "disableCancellationToken=" + encodeURIComponent("" + disableCancellationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSavePdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPdf(id: string, isMobileMedia: boolean): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvas/ExportPdf/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isMobileMedia === undefined || isMobileMedia === null)
            throw new Error("The parameter 'isMobileMedia' must be defined and cannot be null.");
        else
            url_ += "isMobileMedia=" + encodeURIComponent("" + isMobileMedia) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExportPdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessModelCanvasNoteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    paged(businessModelCanvasId: string, model: FilterPagingModel | undefined): Observable<PagedListModelOfBusinessModelCanvasNoteGridModel | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasNote/Paged?";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBusinessModelCanvasNoteGridModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBusinessModelCanvasNoteGridModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBusinessModelCanvasNoteGridModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBusinessModelCanvasNoteGridModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(businessModelCanvasId: string): Observable<BusinessModelCanvasNoteModel[] | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasNote/GetAll?";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasNoteModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasNoteModel[] | null>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BusinessModelCanvasNoteModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasNoteModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBusinessModelCanvasNoteModel | undefined, canvasSubject: BusinessModelCanvasSubject): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasNote/Save?";
        if (canvasSubject === undefined || canvasSubject === null)
            throw new Error("The parameter 'canvasSubject' must be defined and cannot be null.");
        else
            url_ += "canvasSubject=" + encodeURIComponent("" + canvasSubject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applyIndexes(businessModelCanvasId: string, notesListIds: string[] | undefined, canvasSubject: BusinessModelCanvasSubject): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasNote/ApplyIndexes?";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        if (canvasSubject === undefined || canvasSubject === null)
            throw new Error("The parameter 'canvasSubject' must be defined and cannot be null.");
        else
            url_ += "canvasSubject=" + encodeURIComponent("" + canvasSubject) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notesListIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyIndexes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyIndexes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processApplyIndexes(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(businessModelCanvasId: string, id: string): Observable<BusinessModelCanvasNoteModel | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasNote/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasNoteModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasNoteModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessModelCanvasNoteModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasNoteModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(buisnessModelCanvasId: string, id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasNote/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (buisnessModelCanvasId === undefined || buisnessModelCanvasId === null)
            throw new Error("The parameter 'buisnessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "buisnessModelCanvasId=" + encodeURIComponent("" + buisnessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessModelCanvasOverviewService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<BusinessModelCanvasOverviewModel> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasOverview/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasOverviewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasOverviewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessModelCanvasOverviewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasOverviewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranslationByLanguage(): Observable<BusinessModelCanvasOverviewTranslationModel> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasOverview/GetTranslationByLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasOverviewTranslationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasOverviewTranslationModel>;
        }));
    }

    protected processGetTranslationByLanguage(response: HttpResponseBase): Observable<BusinessModelCanvasOverviewTranslationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasOverviewTranslationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBusinessModelCanvasOverviewModel | undefined): Observable<BusinessModelCanvasOverviewModel> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasOverview/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasOverviewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasOverviewModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<BusinessModelCanvasOverviewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasOverviewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessModelCanvasShareService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    paged(id: string, model: BusinessModelCanvasShareFilterPagingModel | undefined): Observable<PagedListModelOfBusinessModelCanvasShareUserModel | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasShare/Paged/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBusinessModelCanvasShareUserModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBusinessModelCanvasShareUserModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBusinessModelCanvasShareUserModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBusinessModelCanvasShareUserModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    invite(businessModelCanvasId: string, model: BusinessModelCanvasShareInviteModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasShare/Invite/{businessModelCanvasId}";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined.");
        url_ = url_.replace("{businessModelCanvasId}", encodeURIComponent("" + businessModelCanvasId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInvite(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reInvite(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasShare/ReInvite/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReInvite(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    accept(inviteConfirmationCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasShare/Accept/{inviteConfirmationCode}";
        if (inviteConfirmationCode === undefined || inviteConfirmationCode === null)
            throw new Error("The parameter 'inviteConfirmationCode' must be defined.");
        url_ = url_.replace("{inviteConfirmationCode}", encodeURIComponent("" + inviteConfirmationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(businessModelCanvasId: string, model: BusinessModelCanvasShareModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasShare/{businessModelCanvasId}";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined.");
        url_ = url_.replace("{businessModelCanvasId}", encodeURIComponent("" + businessModelCanvasId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasShare/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(businessModelCanvasId: string): Observable<BusinessModelCanvasShareUserModel[] | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasShare/GetAll?";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasShareUserModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasShareUserModel[] | null>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BusinessModelCanvasShareUserModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasShareUserModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessModelCanvasSubjectInformationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(businessModelCanvasId: string): Observable<BusinessModelCanvasSubjectInformationModel[] | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasSubjectInformation/GetAll?";
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasSubjectInformationModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasSubjectInformationModel[] | null>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BusinessModelCanvasSubjectInformationModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasSubjectInformationModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBusinessModelCanvasSubjectInformationModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasSubjectInformation/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(businessModelCanvasId: string, id: string): Observable<BusinessModelCanvasSubjectInformationModel | null> {
        let url_ = this.baseUrl + "/api/BusinessModelCanvasSubjectInformation/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (businessModelCanvasId === undefined || businessModelCanvasId === null)
            throw new Error("The parameter 'businessModelCanvasId' must be defined and cannot be null.");
        else
            url_ += "businessModelCanvasId=" + encodeURIComponent("" + businessModelCanvasId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessModelCanvasSubjectInformationModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessModelCanvasSubjectInformationModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessModelCanvasSubjectInformationModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessModelCanvasSubjectInformationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanAdditionalInfoService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string, businessplanPart: BusinessplanPart): Observable<BusinessplanAdditionalInfoModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAdditionalInfo/{businessplanPart}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (businessplanPart === undefined || businessplanPart === null)
            throw new Error("The parameter 'businessplanPart' must be defined.");
        url_ = url_.replace("{businessplanPart}", encodeURIComponent("" + businessplanPart));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanAdditionalInfoModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanAdditionalInfoModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanAdditionalInfoModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanAdditionalInfoModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(businessplanId: string, model: BusinessplanAdditionalInfoModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAdditionalInfo";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveIntroText(businessplanId: string, businessplanPart: BusinessplanPart, introText: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAdditionalInfo/SaveIntroText/{businessplanPart}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (businessplanPart === undefined || businessplanPart === null)
            throw new Error("The parameter 'businessplanPart' must be defined.");
        url_ = url_.replace("{businessplanPart}", encodeURIComponent("" + businessplanPart));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(introText);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveIntroText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveIntroText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveIntroText(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveAnnotation(businessplanId: string, businessplanPart: BusinessplanPart, annotation: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAdditionalInfo/SaveAnnotation/{businessplanPart}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (businessplanPart === undefined || businessplanPart === null)
            throw new Error("The parameter 'businessplanPart' must be defined.");
        url_ = url_.replace("{businessplanPart}", encodeURIComponent("" + businessplanPart));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(annotation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAnnotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAnnotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processSaveAnnotation(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveListItem(businessplanId: string, businessplanPart: BusinessplanPart, model: BusinessplanBooledListItemModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAdditionalInfo/SaveListItem/{businessplanPart}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (businessplanPart === undefined || businessplanPart === null)
            throw new Error("The parameter 'businessplanPart' must be defined.");
        url_ = url_.replace("{businessplanPart}", encodeURIComponent("" + businessplanPart));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveListItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveListItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveListItem(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteListItem(businessplanId: string, id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAdditionalInfo/DeleteListItem/{id}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteListItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteListItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteListItem(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanAnalysisCalculationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanAnalysisCalculationModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAnalysisCalculation";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanAnalysisCalculationModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanAnalysisCalculationModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanAnalysisCalculationModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanAnalysisCalculationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(businessplanId: string, model: BusinessplanAnalysisCalculationModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAnalysisCalculation";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanAnalysisCompetitorService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanCompetitorModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAnalysisCompetitor";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanCompetitorModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanCompetitorModel[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanCompetitorModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanCompetitorModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(businessplanId: string, model: BusinessplanCompetitorModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAnalysisCompetitor";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(businessplanId: string, competitorId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAnalysisCompetitor/{competitorId}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (competitorId === undefined || competitorId === null)
            throw new Error("The parameter 'competitorId' must be defined.");
        url_ = url_.replace("{competitorId}", encodeURIComponent("" + competitorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanAnalysisSwotAnalysisService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanSwotAnalysisModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAnalysisSwotAnalysis";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanSwotAnalysisModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanSwotAnalysisModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanSwotAnalysisModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanSwotAnalysisModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(businessplanId: string, model: BusinessplanSwotAnalysisModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanAnalysisSwotAnalysis";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    paged(model: BusinessplanFilterPagingModel | undefined): Observable<PagedListModelOfBusinessplanListModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBusinessplanListModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBusinessplanListModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBusinessplanListModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBusinessplanListModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfBusinessplanFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(id: string): Observable<BusinessplanModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(id: string, model: SaveBusinessplanModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(model: SaveBusinessplanModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    clone(id: string): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/Clone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    word(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/Word/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processWord(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    pdf(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/Pdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    toggleFreeze(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Businessplan/ToggleFreeze/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleFreeze(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleFreeze(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processToggleFreeze(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLogo(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/DeleteLogo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteLogo(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanInvestmentService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMeasures(businessplanId: string): Observable<BusinessplanInvestmentModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanInvestment/GetMeasures";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMeasures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMeasures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanInvestmentModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanInvestmentModel[] | null>;
        }));
    }

    protected processGetMeasures(response: HttpResponseBase): Observable<BusinessplanInvestmentModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanInvestmentModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    analysis(businessplanId: string): Observable<BusinessplanInvestmentModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanInvestment/Analysis";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnalysis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnalysis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanInvestmentModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanInvestmentModel[] | null>;
        }));
    }

    protected processAnalysis(response: HttpResponseBase): Observable<BusinessplanInvestmentModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanInvestmentModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveMeasures(businessplanId: string, model: BusinessplanInvestmentModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanInvestment/SaveMeasures";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMeasures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMeasures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveMeasures(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveAnalysis(businessplanId: string, model: BusinessplanInvestmentModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanInvestment/SaveAnalysis";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAnalysis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAnalysis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveAnalysis(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(businessplanId: string, id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanInvestment/{id}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanInviteService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(inviteConfirmationCode: string): Observable<BusinessplanInviteModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/BusinessplanInvite/{inviteConfirmationCode}";
        if (inviteConfirmationCode === undefined || inviteConfirmationCode === null)
            throw new Error("The parameter 'inviteConfirmationCode' must be defined.");
        url_ = url_.replace("{inviteConfirmationCode}", encodeURIComponent("" + inviteConfirmationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanInviteModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanInviteModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanInviteModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanInviteModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isInviteAccepted(inviteConfirmationCode: string): Observable<BusinessplanInviteStatusModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/BusinessplanInvite/IsInviteAccepted/{inviteConfirmationCode}";
        if (inviteConfirmationCode === undefined || inviteConfirmationCode === null)
            throw new Error("The parameter 'inviteConfirmationCode' must be defined.");
        url_ = url_.replace("{inviteConfirmationCode}", encodeURIComponent("" + inviteConfirmationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsInviteAccepted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsInviteAccepted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanInviteStatusModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanInviteStatusModel | null>;
        }));
    }

    protected processIsInviteAccepted(response: HttpResponseBase): Observable<BusinessplanInviteStatusModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanInviteStatusModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanManagementSummaryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanManagementSummaryModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanManagementSummary";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanManagementSummaryModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanManagementSummaryModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanManagementSummaryModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanManagementSummaryModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(businessplanId: string, model: BusinessplanManagementSummaryModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanManagementSummary";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanMeasuresInfrastructureService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanInfrastructureModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresInfrastructure";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanInfrastructureModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanInfrastructureModel[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanInfrastructureModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanInfrastructureModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(businessplanId: string, model: SaveBusinessplanInfrastructureModel | undefined): Observable<BusinessplanInfrastructureModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresInfrastructure";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanInfrastructureModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanInfrastructureModel | null>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BusinessplanInfrastructureModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanInfrastructureModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(businessplanId: string, model: BusinessplanInfrastructureModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresInfrastructure";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(businessplanId: string, id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresInfrastructure/{id}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanMeasuresMarketingMeasureService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanMarketingMeasureModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresMarketingMeasure";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanMarketingMeasureModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanMarketingMeasureModel[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanMarketingMeasureModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanMarketingMeasureModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(businessplanId: string, model: SaveBusinessplanMarketingMeasureModel | undefined): Observable<BusinessplanMarketingMeasureModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresMarketingMeasure";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanMarketingMeasureModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanMarketingMeasureModel | null>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BusinessplanMarketingMeasureModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanMarketingMeasureModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(businessplanId: string, model: BusinessplanMarketingMeasureModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresMarketingMeasure";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(businessplanId: string, id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresMarketingMeasure/{id}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanMeasuresProjectService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanProjectModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresProject";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanProjectModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanProjectModel[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanProjectModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanProjectModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(businessplanId: string, model: SaveBusinessplanProjectModel | undefined): Observable<BusinessplanProjectModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresProject";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanProjectModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanProjectModel | null>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BusinessplanProjectModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanProjectModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(businessplanId: string, model: BusinessplanProjectModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresProject";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(businessplanId: string, id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresProject/{id}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanMeasuresStaffPlanningService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanStaffPlanningModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresStaffPlanning";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanStaffPlanningModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanStaffPlanningModel[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanStaffPlanningModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanStaffPlanningModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    create(businessplanId: string, model: SaveBusinessplanStaffPlanningModel | undefined): Observable<BusinessplanStaffPlanningModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresStaffPlanning";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanStaffPlanningModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanStaffPlanningModel | null>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BusinessplanStaffPlanningModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanStaffPlanningModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(businessplanId: string, model: BusinessplanStaffPlanningModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresStaffPlanning";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(businessplanId: string, id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanMeasuresStaffPlanning/{id}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessPlanOverviewService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<BusinessPlanOverviewModel> {
        let url_ = this.baseUrl + "/api/BusinessPlanOverview/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessPlanOverviewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessPlanOverviewModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessPlanOverviewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessPlanOverviewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranslationByLanguage(): Observable<BusinessPlanOverviewTranslationModel> {
        let url_ = this.baseUrl + "/api/BusinessPlanOverview/GetTranslationByLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessPlanOverviewTranslationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessPlanOverviewTranslationModel>;
        }));
    }

    protected processGetTranslationByLanguage(response: HttpResponseBase): Observable<BusinessPlanOverviewTranslationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessPlanOverviewTranslationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveBusinessPlanOverviewModel | undefined): Observable<BusinessPlanOverviewModel> {
        let url_ = this.baseUrl + "/api/BusinessPlanOverview/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessPlanOverviewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessPlanOverviewModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<BusinessPlanOverviewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessPlanOverviewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanPlanCalculationBalanceAndIncomeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanBalanceAndIncomeModelOfBusinessplanPlanYearBalanceAndIncomeDtoModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationBalanceAndIncome";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanBalanceAndIncomeModelOfBusinessplanPlanYearBalanceAndIncomeDtoModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanBalanceAndIncomeModelOfBusinessplanPlanYearBalanceAndIncomeDtoModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanBalanceAndIncomeModelOfBusinessplanPlanYearBalanceAndIncomeDtoModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanBalanceAndIncomeModelOfBusinessplanPlanYearBalanceAndIncomeDtoModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(businessplanId: string, model: BusinessplanBalanceAndIncomeModelOfBusinessplanPlanYearBalanceAndIncomeModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationBalanceAndIncome";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanPlanCalculationCashFlowService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanCashFlowModelOfBusinessplanPlanYearCashFlowDtoModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationCashFlow";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanCashFlowModelOfBusinessplanPlanYearCashFlowDtoModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanCashFlowModelOfBusinessplanPlanYearCashFlowDtoModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanCashFlowModelOfBusinessplanPlanYearCashFlowDtoModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanCashFlowModelOfBusinessplanPlanYearCashFlowDtoModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(businessplanId: string, model: BusinessplanCashFlowModelOfBusinessplanPlanYearCashFlowModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationCashFlow";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanPlanCalculationKeyFiguresService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanKeyFiguresModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationKeyFigures";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanKeyFiguresModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanKeyFiguresModel[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanKeyFiguresModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanKeyFiguresModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanPlanCalculationLiquidityService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanLiquidityModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationLiquidity";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanLiquidityModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanLiquidityModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanLiquidityModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanLiquidityModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(businessplanId: string, model: BusinessplanLiquidityModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationLiquidity";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanPlanCalculationValuationOfCompanyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanValuationOfCompanyModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationValuationOfCompany";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanValuationOfCompanyModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanValuationOfCompanyModel[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanValuationOfCompanyModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanValuationOfCompanyModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSettings(businessplanId: string): Observable<BusinessplanValuationOfCompanySettingsModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationValuationOfCompany/GetSettings";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanValuationOfCompanySettingsModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanValuationOfCompanySettingsModel | null>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<BusinessplanValuationOfCompanySettingsModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanValuationOfCompanySettingsModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateSettings(businessplanId: string, model: BusinessplanValuationOfCompanySettingsModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanPlanCalculationValuationOfCompany/UpdateSettings";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanProductService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(businessplanId: string, analysisYearsOnly: boolean | null): Observable<BusinessplanProductModel[] | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanProduct?";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (analysisYearsOnly === undefined)
            throw new Error("The parameter 'analysisYearsOnly' must be defined.");
        else if(analysisYearsOnly !== null)
            url_ += "analysisYearsOnly=" + encodeURIComponent("" + analysisYearsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanProductModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanProductModel[] | null>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BusinessplanProductModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanProductModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(businessplanId: string, model: BusinessplanProductModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanProduct";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get(businessplanId: string, id: string, analysisYearsOnly: boolean | null): Observable<BusinessplanProductModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanProduct/{id}?";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (analysisYearsOnly === undefined)
            throw new Error("The parameter 'analysisYearsOnly' must be defined.");
        else if(analysisYearsOnly !== null)
            url_ += "analysisYearsOnly=" + encodeURIComponent("" + analysisYearsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanProductModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanProductModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanProductModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanProductModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(businessplanId: string, id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanProduct/{id}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanShareService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    paged(id: string, model: BusinessplanShareFilterPagingModel | undefined): Observable<PagedListModelOfBusinessplanShareUserModel | null> {
        let url_ = this.baseUrl + "/api/BusinessplanShare/Paged/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfBusinessplanShareUserModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfBusinessplanShareUserModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfBusinessplanShareUserModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfBusinessplanShareUserModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    invite(businessplanId: string, model: BusinessplanShareInviteModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/BusinessplanShare/Invite/{businessplanId}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInvite(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reInvite(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessplanShare/ReInvite/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processReInvite(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    accept(inviteConfirmationCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/BusinessplanShare/Accept/{inviteConfirmationCode}";
        if (inviteConfirmationCode === undefined || inviteConfirmationCode === null)
            throw new Error("The parameter 'inviteConfirmationCode' must be defined.");
        url_ = url_.replace("{inviteConfirmationCode}", encodeURIComponent("" + inviteConfirmationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(businessplanId: string, model: BusinessplanShareModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessplanShare/{businessplanId}";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/BusinessplanShare/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BusinessplanStrategyService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(businessplanId: string): Observable<BusinessplanStrategyModel | null> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanStrategy/Get";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BusinessplanStrategyModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BusinessplanStrategyModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessplanStrategyModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessplanStrategyModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(businessplanId: string, model: BusinessplanStrategyModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanStrategy/Save";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    saveTextListItem(businessplanId: string, model: SaveBusinessplanTextListItemModel | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Businessplan/{businessplanId}/BusinessplanStrategy/SaveTextListItem";
        if (businessplanId === undefined || businessplanId === null)
            throw new Error("The parameter 'businessplanId' must be defined.");
        url_ = url_.replace("{businessplanId}", encodeURIComponent("" + businessplanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTextListItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTextListItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveTextListItem(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmailService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string): Observable<EmailModel> {
        let url_ = this.baseUrl + "/api/Email/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paged(model: EmailFilterPagingModel | undefined): Observable<PagedListModelOfOverviewEmailModel | null> {
        let url_ = this.baseUrl + "/api/Email/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfOverviewEmailModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfOverviewEmailModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfOverviewEmailModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfOverviewEmailModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: EmailModel | undefined): Observable<EmailModel> {
        let url_ = this.baseUrl + "/api/Email/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<EmailModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HelpTextService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getById(id: string): Observable<HelpTextModel> {
        let url_ = this.baseUrl + "/api/HelpText/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpTextModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpTextModel>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<HelpTextModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HelpTextModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paged(model: HelpTextFilterPagingModel | undefined): Observable<PagedListModelOfOverviewHelpTextModel | null> {
        let url_ = this.baseUrl + "/api/HelpText/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfOverviewHelpTextModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfOverviewHelpTextModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfOverviewHelpTextModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfOverviewHelpTextModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllIdNameModel(): Observable<IdNameModel[] | null> {
        let url_ = this.baseUrl + "/api/HelpText/GetAllIdNameModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIdNameModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIdNameModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdNameModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdNameModel[] | null>;
        }));
    }

    protected processGetAllIdNameModel(response: HttpResponseBase): Observable<IdNameModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdNameModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfHelpTextFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/HelpText/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: HelpTextModel | undefined): Observable<HelpTextModel> {
        let url_ = this.baseUrl + "/api/HelpText/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpTextModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpTextModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<HelpTextModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HelpTextModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    titleDeactivated(referenceText: string): Observable<HelpTextDeactivatedModel> {
        let url_ = this.baseUrl + "/api/HelpText/TitleDeactivated?";
        if (referenceText === undefined || referenceText === null)
            throw new Error("The parameter 'referenceText' must be defined and cannot be null.");
        else
            url_ += "referenceText=" + encodeURIComponent("" + referenceText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTitleDeactivated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTitleDeactivated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpTextDeactivatedModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpTextDeactivatedModel>;
        }));
    }

    protected processTitleDeactivated(response: HttpResponseBase): Observable<HelpTextDeactivatedModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HelpTextDeactivatedModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getView(referenceText: string): Observable<HelpTextViewModel | null> {
        let url_ = this.baseUrl + "/api/HelpText/GetView?";
        if (referenceText === undefined || referenceText === null)
            throw new Error("The parameter 'referenceText' must be defined and cannot be null.");
        else
            url_ += "referenceText=" + encodeURIComponent("" + referenceText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpTextViewModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpTextViewModel | null>;
        }));
    }

    protected processGetView(response: HttpResponseBase): Observable<HelpTextViewModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HelpTextViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(search: string | null | undefined, includeDeactivated: boolean, placement: HelpTextPlacement | null | undefined): Observable<IdNameModel[] | null> {
        let url_ = this.baseUrl + "/api/HelpText/Search?";
        if (includeDeactivated === undefined || includeDeactivated === null)
            throw new Error("The parameter 'includeDeactivated' must be defined and cannot be null.");
        else
            url_ += "includeDeactivated=" + encodeURIComponent("" + includeDeactivated) + "&";
        if (placement !== undefined && placement !== null)
            url_ += "placement=" + encodeURIComponent("" + placement) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdNameModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdNameModel[] | null>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<IdNameModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdNameModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InfoTextService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string): Observable<InfoTextModel> {
        let url_ = this.baseUrl + "/api/InfoText/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoTextModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoTextModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InfoTextModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InfoTextModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInfoTextsForHomeView(): Observable<InfoTextHomeViewModel[]> {
        let url_ = this.baseUrl + "/api/InfoText/GetInfoTextsForHomeView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfoTextsForHomeView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfoTextsForHomeView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoTextHomeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoTextHomeViewModel[]>;
        }));
    }

    protected processGetInfoTextsForHomeView(response: HttpResponseBase): Observable<InfoTextHomeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InfoTextHomeViewModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paged(model: InfoTextFilterPagingModel | undefined): Observable<PagedListModelOfOverviewInfoTextModel | null> {
        let url_ = this.baseUrl + "/api/InfoText/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfOverviewInfoTextModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfOverviewInfoTextModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfOverviewInfoTextModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfOverviewInfoTextModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(search: string | null | undefined, includeDeactivated: boolean): Observable<IdNameModel[] | null> {
        let url_ = this.baseUrl + "/api/InfoText/Search?";
        if (includeDeactivated === undefined || includeDeactivated === null)
            throw new Error("The parameter 'includeDeactivated' must be defined and cannot be null.");
        else
            url_ += "includeDeactivated=" + encodeURIComponent("" + includeDeactivated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(search);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdNameModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdNameModel[] | null>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<IdNameModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdNameModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveInfoTextModel | undefined): Observable<InfoTextModel> {
        let url_ = this.baseUrl + "/api/InfoText/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfoTextModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfoTextModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<InfoTextModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InfoTextModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfInfoTextFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InfoText/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivate(id: string, deactivate: boolean | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/InfoText/Deactivate?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deactivate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DocumentsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<DocumentsModel> {
        let url_ = this.baseUrl + "/api/Documents/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentsModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranslationByLanguage(): Observable<DocumentsTranslationModel> {
        let url_ = this.baseUrl + "/api/Documents/GetTranslationByLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentsTranslationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentsTranslationModel>;
        }));
    }

    protected processGetTranslationByLanguage(response: HttpResponseBase): Observable<DocumentsTranslationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsTranslationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveDocumentsModel | undefined): Observable<DocumentsModel> {
        let url_ = this.baseUrl + "/api/Documents/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentsModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentsModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<DocumentsModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentsModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HomeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<HomeModel> {
        let url_ = this.baseUrl + "/api/Home/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HomeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomeModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranslationByLanguage(): Observable<HomeTranslationModel> {
        let url_ = this.baseUrl + "/api/Home/GetTranslationByLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeTranslationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeTranslationModel>;
        }));
    }

    protected processGetTranslationByLanguage(response: HttpResponseBase): Observable<HomeTranslationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomeTranslationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveHomeModel | undefined): Observable<HomeModel> {
        let url_ = this.baseUrl + "/api/Home/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HomeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HomeModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<HomeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomeModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SubpageService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(type: Subpages): Observable<SubpageModel> {
        let url_ = this.baseUrl + "/api/Subpage/Get/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubpageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubpageModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SubpageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubpageModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranslationByType(type: Subpages): Observable<SubpageTranslationModel> {
        let url_ = this.baseUrl + "/api/Subpage/GetTranslationByType/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubpageTranslationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubpageTranslationModel>;
        }));
    }

    protected processGetTranslationByType(response: HttpResponseBase): Observable<SubpageTranslationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubpageTranslationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveSubpageModel | undefined): Observable<SubpageModel> {
        let url_ = this.baseUrl + "/api/Subpage/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubpageModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubpageModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<SubpageModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubpageModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IncorporationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<IncorporationModel> {
        let url_ = this.baseUrl + "/api/Incorporation/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncorporationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncorporationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IncorporationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncorporationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranslationByLanguage(): Observable<IncorporationTranslationModel> {
        let url_ = this.baseUrl + "/api/Incorporation/GetTranslationByLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncorporationTranslationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncorporationTranslationModel>;
        }));
    }

    protected processGetTranslationByLanguage(response: HttpResponseBase): Observable<IncorporationTranslationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncorporationTranslationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveIncorporationModel | undefined): Observable<IncorporationModel> {
        let url_ = this.baseUrl + "/api/Incorporation/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncorporationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncorporationModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<IncorporationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IncorporationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<LanguageModel[] | null> {
        let url_ = this.baseUrl + "/api/Language/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageModel[] | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LanguageModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LanguageModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MfaService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEnableAuthenticatorInformation(): Observable<EnableAuthenticatorModel | null> {
        let url_ = this.baseUrl + "/api/Mfa/GetEnableAuthenticatorInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnableAuthenticatorInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnableAuthenticatorInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnableAuthenticatorModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnableAuthenticatorModel | null>;
        }));
    }

    protected processGetEnableAuthenticatorInformation(response: HttpResponseBase): Observable<EnableAuthenticatorModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnableAuthenticatorModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    enableAuthenticator(codeModel: AuthenticationCodeModel | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Mfa/EnableAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(codeModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processEnableAuthenticator(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    authenticateByAuthenticator(codeModel: AuthenticationCodeModel | undefined): Observable<AuthenticationModel | null> {
        let url_ = this.baseUrl + "/api/Mfa/AuthenticateByAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(codeModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateByAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateByAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticationModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticationModel | null>;
        }));
    }

    protected processAuthenticateByAuthenticator(response: HttpResponseBase): Observable<AuthenticationModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthenticationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeAuthenticatorActivity(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Mfa/ChangeAuthenticatorActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAuthenticatorActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAuthenticatorActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangeAuthenticatorActivity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetRecoveryCodes(): Observable<AuthenticatorKeysModel | null> {
        let url_ = this.baseUrl + "/api/Mfa/ResetRecoveryCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetRecoveryCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetRecoveryCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticatorKeysModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticatorKeysModel | null>;
        }));
    }

    protected processResetRecoveryCodes(response: HttpResponseBase): Observable<AuthenticatorKeysModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthenticatorKeysModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeAuthenticator(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Mfa/RemoveAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRemoveAuthenticator(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    recoveryCodesPdf(authenticatorKeys: AuthenticatorKeysModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Mfa/RecoveryCodesPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authenticatorKeys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoveryCodesPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoveryCodesPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRecoveryCodesPdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MutationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<MutationModel> {
        let url_ = this.baseUrl + "/api/Mutation/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutationModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MutationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MutationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTranslationByLanguage(): Observable<MutationTranslationModel> {
        let url_ = this.baseUrl + "/api/Mutation/GetTranslationByLanguage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTranslationByLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTranslationByLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutationTranslationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutationTranslationModel>;
        }));
    }

    protected processGetTranslationByLanguage(response: HttpResponseBase): Observable<MutationTranslationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MutationTranslationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveMutationModel | undefined): Observable<MutationModel> {
        let url_ = this.baseUrl + "/api/Mutation/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MutationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MutationModel>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<MutationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MutationModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SalutationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSalutations(languageCode: string): Observable<SalutationModel[] | null> {
        let url_ = this.baseUrl + "/api/Salutation/GetSalutations/{languageCode}";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalutations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalutations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalutationModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalutationModel[] | null>;
        }));
    }

    protected processGetSalutations(response: HttpResponseBase): Observable<SalutationModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalutationModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StatisticsService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    paged(model: TrafficLogFilterPagingModel | undefined): Observable<PagedListModelOfTrafficLogModel | null> {
        let url_ = this.baseUrl + "/api/Statistics/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfTrafficLogModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfTrafficLogModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfTrafficLogModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfTrafficLogModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfTrafficLogFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Statistics/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Observable<ThemeModel | null> {
        let url_ = this.baseUrl + "/api/Theme/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeModel | null>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ThemeModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThemeModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    logo(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Theme/Logo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processLogo(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    save(model: SaveThemeModel | undefined): Observable<ThemeModel | null> {
        let url_ = this.baseUrl + "/api/Theme/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeModel | null>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<ThemeModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ThemeModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TranslationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAllTranslations(languageCode: string, v: string | null | undefined): Observable<any | null> {
        let url_ = this.baseUrl + "/api/Translation/{languageCode}?";
        if (languageCode === undefined || languageCode === null)
            throw new Error("The parameter 'languageCode' must be defined.");
        url_ = url_.replace("{languageCode}", encodeURIComponent("" + languageCode));
        if (v !== undefined && v !== null)
            url_ += "v=" + encodeURIComponent("" + v) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any | null>;
        }));
    }

    protected processGetAllTranslations(response: HttpResponseBase): Observable<any | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUserProfile(): Observable<UserProfileModel | null> {
        let url_ = this.baseUrl + "/api/User/GetUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileModel | null>;
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<UserProfileModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserProfile(model: UpdateUserProfileModel | undefined): Observable<UserProfileModel | null> {
        let url_ = this.baseUrl + "/api/User/UpdateUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileModel | null>;
        }));
    }

    protected processUpdateUserProfile(response: HttpResponseBase): Observable<UserProfileModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    register(model: RegisterUserModel | undefined, redirectionLink: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/Register?";
        if (redirectionLink !== undefined && redirectionLink !== null)
            url_ += "redirectionLink=" + encodeURIComponent("" + redirectionLink) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    verifyCode(inviteConfirmationCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/User/VerifyCode/{inviteConfirmationCode}";
        if (inviteConfirmationCode === undefined || inviteConfirmationCode === null)
            throw new Error("The parameter 'inviteConfirmationCode' must be defined.");
        url_ = url_.replace("{inviteConfirmationCode}", encodeURIComponent("" + inviteConfirmationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processVerifyCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    accept(inviteConfirmationCode: string): Observable<string> {
        let url_ = this.baseUrl + "/api/User/Accept/{inviteConfirmationCode}";
        if (inviteConfirmationCode === undefined || inviteConfirmationCode === null)
            throw new Error("The parameter 'inviteConfirmationCode' must be defined.");
        url_ = url_.replace("{inviteConfirmationCode}", encodeURIComponent("" + inviteConfirmationCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccept(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccept(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAccept(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(model: ResetPasswordModel | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    newPassword(model: NewPasswordModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/User/NewPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processNewPassword(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(model: ChangePasswordModel | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteMyAccount(model: DeleteMyAccountModel | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/DeleteMyAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteMyAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteMyAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteMyAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    paged(model: UserFilterPagingModel | undefined): Observable<PagedListModelOfUserModel | null> {
        let url_ = this.baseUrl + "/api/User/Paged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListModelOfUserModel | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListModelOfUserModel | null>;
        }));
    }

    protected processPaged(response: HttpResponseBase): Observable<PagedListModelOfUserModel | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedListModelOfUserModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllIdNameModel(): Observable<IdNameModel[] | null> {
        let url_ = this.baseUrl + "/api/User/GetAllIdNameModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllIdNameModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllIdNameModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdNameModel[] | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdNameModel[] | null>;
        }));
    }

    protected processGetAllIdNameModel(response: HttpResponseBase): Observable<IdNameModel[] | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdNameModel[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    excel(model: GridExportModelOfUserFilterPagingModel | undefined, timeZone: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/User/Excel?";
        if (timeZone === undefined || timeZone === null)
            throw new Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTermsAndPolicies(model: UserTermsAndPoliciesModel | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/UpdateTermsAndPolicies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTermsAndPolicies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTermsAndPolicies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateTermsAndPolicies(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeUserRole(userId: string, newUserRight: Rights): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/User/ChangeUserRole?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (newUserRight === undefined || newUserRight === null)
            throw new Error("The parameter 'newUserRight' must be defined and cannot be null.");
        else
            url_ += "newUserRight=" + encodeURIComponent("" + newUserRight) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processChangeUserRole(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUserAccount(userId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/User/DeleteUserAccount?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDeleteUserAccount(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IdModel {
    id?: string | null;
}

export interface AboutModel extends IdModel {
    translations: AboutTranslationModel[];
}

export interface AboutTranslationModel {
    mainTitle?: string | null;
    contactTitle?: string | null;
    contact?: string | null;
    instructionTitle?: string | null;
    instructionsFirstPhrase?: string | null;
    instructionsSecondPhrase?: string | null;
    instructionsFirstFileTitle?: string | null;
    instructionsSecondFileTitle?: string | null;
    aboutFreeText?: string | null;
    instructionsFirstPdfFile?: FileEntryModel | null;
    instructionsSecondPdfFile?: FileEntryModel | null;
    impressumPdfFile?: FileEntryModel | null;
    dataProtectionPdfFile?: FileEntryModel | null;
    languageCode: string;
}

export interface FileEntryModel {
    id: string;
    type: string;
    name: string;
}

export interface SaveAboutModel extends IdModel {
    translations: SaveAboutTranslationModel[];
}

export interface SaveAboutTranslationModel {
    mainTitle?: string | null;
    contactTitle?: string | null;
    contact?: string | null;
    instructionTitle?: string | null;
    instructionsFirstPhrase?: string | null;
    instructionsSecondPhrase?: string | null;
    instructionsFirstFileTitle?: string | null;
    instructionsSecondFileTitle?: string | null;
    aboutFreeText?: string | null;
    instructionsFirstPdfFile?: SaveFileModel | null;
    instructionsSecondPdfFile?: SaveFileModel | null;
    impressumPdfFile?: SaveFileModel | null;
    dataProtectionPdfFile?: SaveFileModel | null;
    languageCode: string;
}

export interface SaveFileModel {
    id?: string | null;
    name: string;
    type: string;
    data: string;
}

export interface AuthenticationModel {
    userId: string;
    displayName: string;
    firstname: string;
    lastname: string;
    email: string;
    termsOfUse: boolean;
    dataProcessingAgreement: boolean;
    dataProtectionPolicy: boolean;
    token: string;
    refreshToken: string;
    hasToMfa: boolean;
    rememberMeToken: string;
    twoFactorEnabled: boolean;
    twoFactorActive: boolean;
    lastDateTwoFactorReminded?: Date | null;
    roleKeys: string[];
    rightKeys: Rights[];
    validUntil?: Date | null;
    isSystemUser: boolean;
}

export enum Rights {
    SystemAdministrator = 0,
    User = 1,
    SuperAdministrator = 2,
}

export interface AuthenticateModel {
    loginName: string;
    password: string;
    rememberMeToken?: string | null;
}

export interface RefreshAuthenticationModel {
    refreshToken: string;
}

export interface BlogCategoryModel {
    id: string;
    translations: BlogCategoryTranslationModel[];
}

export interface BlogCategoryTranslationModel {
    name: string;
    languageCode: string;
}

export interface SaveBlogCategoryModel {
    id?: string | null;
    translations: SaveBlogCategoryTranslationModel[];
}

export interface SaveBlogCategoryTranslationModel {
    name: string;
    languageCode: string;
}

export interface PagedListModelOfBlogCategoryListModel {
    items: BlogCategoryListModel[];
    totalItemCount: number;
}

export interface BlogCategoryListModel {
    id: string;
    name?: string | null;
    savedDate?: Date | null;
    savedUserFullName: string;
    deactivated: boolean;
}

export interface SortAndPagingModel {
    pageNumber: number;
    pageSize: number;
    sort?: string | null;
    sortDirection: SortDirection;
}

export interface FilterPagingModel extends SortAndPagingModel {
    numberFilters?: FilterOfNumberFilterType[] | null;
    stringFilters?: FilterOfStringFilterType[] | null;
    dateTimeFilters?: FilterOfDateTimeFilterType[] | null;
    boolFilters?: FilterOfBoolFilterType[] | null;
    guidFilters?: FilterOfGuidFilterType[] | null;
    enumFilters?: FilterOfEnumFilterType[] | null;
}

export interface BlogCategoryFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
    includeDeactivated: boolean;
}

export interface FilterOfNumberFilterType {
    filterType: NumberFilterType;
    values: any[];
    name: string;
}

export enum NumberFilterType {
    Equals = 0,
    GreaterThan = 1,
    GreaterThanOrEqual = 2,
    LessThan = 4,
    LessThanOrEqual = 8,
    Between = 16,
}

export interface FilterOfStringFilterType {
    filterType: StringFilterType;
    values: any[];
    name: string;
}

export enum StringFilterType {
    Contains = 0,
    StartsWith = 1,
    EndsWith = 2,
}

export interface FilterOfDateTimeFilterType {
    filterType: DateTimeFilterType;
    values: any[];
    name: string;
}

export enum DateTimeFilterType {
    Equals = 0,
    GreaterThan = 1,
    GreaterThanOrEqual = 2,
    LessThan = 4,
    LessThanOrEqual = 8,
    Between = 16,
}

export interface FilterOfBoolFilterType {
    filterType: BoolFilterType;
    values: any[];
    name: string;
}

export enum BoolFilterType {
    Equals = 0,
}

export interface FilterOfGuidFilterType {
    filterType: GuidFilterType;
    values: any[];
    name: string;
}

export enum GuidFilterType {
    Equals = 0,
    Contains = 1,
}

export interface FilterOfEnumFilterType {
    filterType: EnumFilterType;
    values: any[];
    name: string;
}

export enum EnumFilterType {
    Equals = 0,
    Contains = 1,
}

export enum SortDirection {
    None = 0,
    Ascending = 1,
    Descending = 2,
}

export interface SearchBlogCategoryResultModel {
    id: string;
    name: string;
}

export interface SearchBlogCategoryModel {
    id?: string | null;
    text?: string | null;
    excludeIds?: string[] | null;
}

export interface GridExportModelOfBlogCategoryFilterPagingModel {
    filterPaging: BlogCategoryFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface BlogModel {
    id: string;
    deactivated: boolean;
    from?: Date | null;
    to?: Date | null;
    author?: string | null;
    showAuthor: boolean;
    savedDate: Date;
    category?: BlogBlogCategoryModel | null;
    translations: BlogTranslationModel[];
    tags: BlogBlogTagModel[];
}

export interface BlogBlogCategoryModel {
    id: string;
    name: string;
}

export interface BlogTranslationModel {
    title: string;
    overviewImage?: FileEntryModel | null;
    overviewText: string;
    introductionText?: string | null;
    detailImage?: FileEntryModel | null;
    detailText: string;
    languageCode: string;
}

export interface BlogBlogTagModel {
    id: string;
    name: string;
}

export interface SaveBlogModel {
    id?: string | null;
    deactivated: boolean;
    from?: Date | null;
    to?: Date | null;
    author?: string | null;
    showAuthor: boolean;
    category?: SaveBlogCategoryModel2 | null;
    translations: SaveBlogTranslationModel[];
    tags: SaveBlogBlogTagModel[];
}

export interface SaveBlogCategoryModel2 {
    id?: string | null;
}

export interface SaveBlogTranslationModel {
    title: string;
    overviewImage?: SaveFileModel | null;
    overviewText: string;
    introductionText?: string | null;
    detailImage?: SaveFileModel | null;
    detailText: string;
    languageCode: string;
}

export interface SaveBlogBlogTagModel {
    id: string;
}

export interface PagedListModelOfBlogListModel {
    items: BlogListModel[];
    totalItemCount: number;
}

export interface BlogListModel {
    id: string;
    title?: string | null;
    overviewText?: string | null;
    overviewImage?: FileEntryModel | null;
    blogCategoryId?: string | null;
    blogCategoryName?: string | null;
    blogTags: string[];
    savedDate?: Date | null;
    savedUserFullName: string;
    deactivated: boolean;
    to?: Date | null;
}

export interface BlogFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
    includeDeactivated: boolean;
    blogCategoryId?: string | null;
    blogTagIds?: string[] | null;
    similarToBlogId?: string | null;
}

export interface GridExportModelOfBlogFilterPagingModel {
    filterPaging: BlogFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface BlogTagModel {
    id: string;
    translations: BlogTagTranslationModel[];
}

export interface BlogTagTranslationModel {
    name: string;
    languageCode: string;
}

export interface SaveBlogTagModel {
    id?: string | null;
    translations: SaveBlogTagTranslationModel[];
}

export interface SaveBlogTagTranslationModel {
    name: string;
    languageCode: string;
}

export interface PagedListModelOfBlogTagListModel {
    items: BlogTagListModel[];
    totalItemCount: number;
}

export interface BlogTagListModel {
    id: string;
    name?: string | null;
    savedDate?: Date | null;
    savedUserFullName: string;
    deactivated: boolean;
}

export interface BlogTagFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
    includeDeactivated: boolean;
}

export interface SearchBlogTagResultModel {
    id: string;
    name: string;
}

export interface SearchBlogTagModel {
    id?: string | null;
    blogCategoryId?: string | null;
    text?: string | null;
    excludeIds?: string[] | null;
}

export interface GridExportModelOfBlogTagFilterPagingModel {
    filterPaging: BlogTagFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface PagedListModelOfBusinessModelCanvasCommentGridModel {
    items: BusinessModelCanvasCommentGridModel[];
    totalItemCount: number;
}

export interface BusinessModelCanvasCommentGridModel {
    id: string;
    description: string;
    canvasSubject: BusinessModelCanvasSubject;
    canvasSubjectTitleInformation?: string | null;
    businessModelCanvasId: string;
    createUserName: string;
}

export enum BusinessModelCanvasSubject {
    KeyPartners = 0,
    KeyActivities = 1,
    ValuePropositions = 2,
    CustomerRelationships = 3,
    CustomerSegments = 4,
    KeyResources = 5,
    Channels = 6,
    CostStructure = 7,
    RevenueStreams = 8,
}

export interface BusinessModelCanvasCommentModel {
    id: string;
    description: string;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
    createUserName: string;
    createDate: Date;
    updateUserName: string;
    updateDate?: Date | null;
}

export interface SaveBusinessModelCanvasCommentModel {
    id?: string | null;
    description: string;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
    mentionedUsers?: BusinessModelCanvasShareUserModel[] | null;
}

export interface BusinessModelCanvasShareUserModel {
    id: string;
    email: string;
    fullName: string;
    role: BusinessModelCanvasShareRole;
    sharedAt: Date;
    accepted: boolean;
}

export enum BusinessModelCanvasShareRole {
    Viewer = 0,
    User = 1,
    Admin = 2,
}

export interface PagedListModelOfBusinessModelCanvasListModel {
    items: BusinessModelCanvasListModel[];
    totalItemCount: number;
}

export interface BusinessModelCanvasListModel {
    id: string;
    name: string;
    role: BusinessModelCanvasShareRole;
    createUserName: string;
    createDate: Date;
    updateUserName: string;
    updateDate?: Date | null;
}

export interface BusinessModelCanvasFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
}

export interface GridExportModelOfBusinessModelCanvasFilterPagingModel {
    filterPaging: BusinessModelCanvasFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface SaveBusinessModelCanvasModel {
    id?: string | null;
    name: string;
}

export interface BusinessModelCanvasModel {
    id: string;
    name: string;
    canEdit: boolean;
    businessModelCanvasRole: BusinessModelCanvasShareRole;
    notes?: BusinessModelCanvasNoteEntity[] | null;
    comments?: BusinessModelCanvasCommentEntity[] | null;
    subjectsInformation?: BusinessModelCanvasSubjectInformationEntity[] | null;
}

export interface BaseCreatedEntity {
    createdUserId: string;
    createdUser: UserEntity;
    createdDate: Date;
}

export interface BaseCreatedModifiedEntity extends BaseCreatedEntity {
    modifiedUserId?: string | null;
    modifiedUser?: UserEntity | null;
    modifiedDate?: Date | null;
}

export interface BaseCreatedModifiedSavedEntity extends BaseCreatedModifiedEntity {
    savedUserId: string;
    savedUser: UserEntity;
    savedDate: Date;
}

export interface BusinessModelCanvasNoteEntity extends BaseCreatedModifiedSavedEntity {
    id: string;
    title: string;
    description?: string | null;
    color: string;
    index: number;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
    businessModelCanvas: BusinessModelCanvasEntity;
}

export interface BusinessModelCanvasEntity extends BaseCreatedModifiedSavedEntity {
    id: string;
    name: string;
    pdfFileId?: string | null;
    pdfFile?: FileEntryEntity | null;
    notes?: BusinessModelCanvasNoteEntity[] | null;
    comments?: BusinessModelCanvasCommentEntity[] | null;
    subjectsInformation: BusinessModelCanvasSubjectInformationEntity[];
    sharedBusinessModelCanvases: BusinessModelCanvasShareEntity[];
}

export interface FileEntryEntity extends BaseCreatedModifiedEntity {
    id: string;
    name: string;
    type: string;
    isPublic: boolean;
    data: string;
}

export interface IdentityUserOfGuid {
    id: string;
    userName?: string | null;
    normalizedUserName?: string | null;
    email?: string | null;
    normalizedEmail?: string | null;
    emailConfirmed: boolean;
    passwordHash?: string | null;
    securityStamp?: string | null;
    concurrencyStamp?: string | null;
    phoneNumber?: string | null;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd?: Date | null;
    lockoutEnabled: boolean;
    accessFailedCount: number;
}

export interface UserEntity extends IdentityUserOfGuid {
    businessModelCanvasShares: BusinessModelCanvasShareEntity[];
    businessplanShares: BusinessplanShareEntity[];
    firstname: string;
    lastname: string;
    company?: string | null;
    city: string;
    street: string;
    streetNumber: string;
    zip: number;
    twoFactorActive: boolean;
    termsOfUseAccepted: Date;
    dataProcessingAgreementAccepted: Date;
    dataProtectionPolicyAccepted: Date;
    inviteConfirmationCode?: string | null;
    inviteConfirmationCodeDate?: Date | null;
    inviteConfirmationCodeValidUntil?: Date | null;
    lastLoginDate?: Date | null;
    lastDateTwoFactorReminded?: Date | null;
    avatarFileEntryId?: string | null;
    avatarFileEntry?: FileEntryEntity | null;
    salutationId?: string | null;
    salutation?: SalutationEntity | null;
    userRoles: UserRoleEntity[];
    isSystemUser: boolean;
    deletedDate?: Date | null;
    createdDate: Date;
}

export interface BusinessModelCanvasShareEntity extends BaseCreatedModifiedEntity {
    id: string;
    userId?: string | null;
    businessModelCanvasId: string;
    role: BusinessModelCanvasShareRole;
    inviteConfirmationDate?: Date | null;
    user?: UserEntity | null;
    businessModelCanvas: BusinessModelCanvasEntity;
    invite?: BusinessModelCanvasInviteEntity | null;
}

export interface BusinessModelCanvasInviteEntity {
    id: string;
    salutationId: string;
    email: string;
    firstName: string;
    lastName: string;
    inviterUserId: string;
    inviteConfirmationCode: string;
    inviteConfirmationCodeValidUntil: Date;
    sharedBusinessModelCanvasId: string;
    sharedBusinessModelCanvas: BusinessModelCanvasShareEntity;
    inviterUser: UserEntity;
    fullName: string;
}

export interface BusinessplanShareEntity extends BaseCreatedModifiedEntity {
    id: string;
    userId?: string | null;
    businessplanId: string;
    role: BusinessplanShareRole;
    inviteConfirmationDate?: Date | null;
    user?: UserEntity | null;
    businessplan: BusinessplanEntity;
    invite?: BusinessplanInviteEntity | null;
}

export enum BusinessplanShareRole {
    Viewer = 0,
    User = 1,
    Admin = 2,
}

export interface BusinessplanEntity extends BaseCreatedModifiedSavedEntity {
    id: string;
    type: PlanType;
    name: string;
    frozen: boolean;
    currency: Currency;
    numberFormat: NumberFormat;
    firstPlanningYear: number;
    countAnalysisYears?: number | null;
    countPlanningYears?: number | null;
    foundationDate?: Date | null;
    termOfPaymentDebitorsInDays?: number | null;
    termOfPaymentCreditorsInDays?: number | null;
    stockTurnoverInDays?: number | null;
    amountOfIncomeTaxInPercent?: number | null;
    shortDatedInterestOfCreditCapitalAJinPercent?: number | null;
    longDatedInterestOfCreditCapitalAJinPercent?: number | null;
    shortDatedInterestOfCreditCapitalPJinPercent?: number | null;
    longDatedInterestOfCreditCapitalPJinPercent?: number | null;
    languageCode?: string | null;
    language: LanguageEntity;
    address: BusinessplanAddressEntity;
    valuationOfCompanySettings: BusinessplanValuationOfCompanySettingsEntity;
    analysis: BusinessplanAnalysisEntity;
    strategy: BusinessplanStrategyEntity;
    measures: BusinessplanMeasuresEntity;
    liquidity: BusinessplanLiquidityEntity;
    managementSummary: BusinessplanManagementSummaryEntity;
    logoImageFileEntryId?: string | null;
    logoImageFileEntry?: FileEntryEntity | null;
    authors: BusinessplanAuthorEntity[];
    products: BusinessplanProductEntity[];
    analysisYears: BusinessplanAnalysisYearEntity[];
    planYears: BusinessplanPlanYearEntity[];
    additionalInfos: BusinessplanAdditionalInfoEntity[];
    sharedBusinessplans: BusinessplanShareEntity[];
}

export enum PlanType {
    Template = 0,
    Plan = 1,
}

export enum Currency {
    CHF = 0,
    EUR = 1,
    USD = 2,
    GBP = 3,
}

export enum NumberFormat {
    Apostroph = 0,
    Point = 1,
}

export interface LanguageEntity {
    code: string;
}

export interface BusinessplanAddressEntity {
    companyname: string;
    street: string;
    postalCode: string;
    city: string;
    phoneNumber: string;
    homepage: string;
    email: string;
}

export interface BusinessplanValuationOfCompanySettingsEntity {
    discountRate: number;
    growth: number;
    multiple: number;
}

export interface BusinessplanAnalysisEntity {
    id: string;
    businessplan: BusinessplanEntity;
    competitors: BusinessplanCompetitorEntity[];
    investments: BusinessplanInvestmentEntity[];
    textListItems: BusinessplanTextListItemEntity[];
    swotStrengths: BusinessplanTextListItemEntity[];
    swotWeaknesses: BusinessplanTextListItemEntity[];
    swotOpportunities: BusinessplanTextListItemEntity[];
    swotThreats: BusinessplanTextListItemEntity[];
    swotFindings: BusinessplanTextListItemEntity[];
}

export interface BusinessplanCompetitorEntity {
    id: string;
    analysisId: string;
    analysis: BusinessplanAnalysisEntity;
    name: string;
    postalCode: string;
    city: string;
    description: string;
    employeeCount?: number | null;
    totalRevenue?: number | null;
    products: string;
    services: string;
    strengths: string;
    weaknesses: string;
    expectedStrategy: string;
    expectedMeasures: string;
}

export interface BusinessplanInvestmentEntity {
    id: string;
    measuresId?: string | null;
    analysisId?: string | null;
    description: string;
    type: InvestmentType;
    amount: number;
    purchaseYear: number;
    usageYears: number;
}

export enum InvestmentType {
    Maschinen = 0,
    Mobilien = 1,
    IT = 2,
    Fahrzeuge = 3,
    Immobilien = 4,
}

export interface BusinessplanListItemEntity {
    id: string;
    text: string;
    itemType: ListItemType;
    additionalInfo?: BusinessplanAdditionalInfoEntity | null;
    additionalInfoId?: string | null;
    managementSummaryId?: string | null;
    analysisId?: string | null;
    strategyId?: string | null;
}

export interface BusinessplanTextListItemEntity extends BusinessplanListItemEntity {
}

export enum ListItemType {
    Attachement = 0,
    ManagementSummaryAchievment = 1,
    ManagementSummaryActivity = 2,
    ManagementSummaryApplication = 3,
    ManagementSummaryArgument = 4,
    ManagementSummaryCustomerBenefit = 5,
    ManagementSummaryMilestone = 6,
    ManagementSummaryProtectionCompetitor = 7,
    StrategyCustomer = 8,
    StrategyMarket = 9,
    StrategyPartner = 10,
    SwotFinding = 11,
    SwotOpportunity = 12,
    SwotStrength = 13,
    SwotThreat = 14,
    SwotWeakness = 15,
}

export interface BusinessplanAdditionalInfoEntity {
    id: string;
    businessplanPart: BusinessplanPart;
    businessplanId: string;
    businessplan: BusinessplanEntity;
    introText: string;
    annotation: string;
    attachements: BusinessplanBooledListItemEntity[];
}

export enum BusinessplanPart {
    Unknown = 0,
    AnalysisCalculation = 1,
    AnalysisCompetitor = 2,
    AnalysisEconomics = 3,
    AnalysisInfrastructure = 4,
    AnalysisSwot = 5,
    ManagementSummaryAchievement = 6,
    ManagementSummaryActivity = 7,
    ManagementSummaryApplication = 8,
    ManagementSummaryArgument = 9,
    ManagementSummaryCustomerBenefit = 10,
    ManagementSummaryIdeaBackground = 11,
    ManagementSummaryLegal = 12,
    ManagementSummaryMilestone = 13,
    ManagementSummaryProtection = 14,
    ManagementSummaryVision = 15,
    MeasuresInfrastructure = 16,
    MeasuresInvestment = 17,
    MeasuresProject = 18,
    MeasuresMarketingMeasure = 19,
    MeasuresStaffPlanning = 20,
    PlanCalculationBalanceAndIncome = 21,
    PlanCalculationCashFlow = 22,
    PlanCalculationLiquidity = 23,
    PlanCalculationKeyFigures = 24,
    PlanCalculationValuationOfCompany = 25,
    Strategy = 26,
    StrategyProducts = 27,
    StrategyCustomers = 28,
    StrategyMarkets = 29,
    StrategyPartners = 30,
}

export interface BusinessplanBooledListItemEntity extends BusinessplanListItemEntity {
    isChecked: boolean;
}

export interface BusinessplanStrategyEntity {
    id: string;
    businessplan: BusinessplanEntity;
    customerIntroText?: string | null;
    customerAnnotation?: string | null;
    marketIntroText?: string | null;
    marketAnnotation?: string | null;
    partnerIntroText?: string | null;
    partnerAnnotation?: string | null;
    textListItems: BusinessplanTextListItemEntity[];
    customers: BusinessplanTextListItemEntity[];
    markets: BusinessplanTextListItemEntity[];
    partners: BusinessplanTextListItemEntity[];
}

export interface BusinessplanMeasuresEntity {
    id: string;
    businessplan: BusinessplanEntity;
    marketingMeasures: BusinessplanMarketingMeasureEntity[];
    projects: BusinessplanProjectEntity[];
    staffPlannings: BusinessplanStaffPlanningEntity[];
    infrastructures: BusinessplanInfrastructureEntity[];
    investments: BusinessplanInvestmentEntity[];
}

export interface BusinessplanMarketingMeasureEntity {
    id: string;
    businessplanId: string;
    measures: BusinessplanMeasuresEntity;
    targetGroup: TargetGroup;
    marketingMeasureType: MarketingMeasureType;
    description: string;
    marketingMeasureYears: BusinessplanMarketingMeasureYearEntity[];
}

export enum TargetGroup {
    ExterneBeeinflusser = 0,
    Produktverwender = 1,
    Zwischenhaendler = 2,
}

export enum MarketingMeasureType {
    Zusatzdienstleistungen = 0,
    PricingKonditionen = 1,
    Verkauf = 2,
    WerbungPR = 3,
    Verkaufsfoerderung = 4,
    MessenEvents = 5,
    DirectMarketing = 6,
    KundenbindungCRM = 7,
    DistributionLogistik = 8,
    Multichannelmarketing = 9,
}

export interface BusinessplanYearEntity {
    id: string;
    year: number;
}

export interface BusinessplanMarketingMeasureYearEntity extends BusinessplanYearEntity {
    marketingMeasureId: string;
    marketingMeasure: BusinessplanMarketingMeasureEntity;
    amount: number;
}

export interface BusinessplanProjectEntity {
    id: string;
    businessplanId: string;
    measures: BusinessplanMeasuresEntity;
    name: string;
    description: string;
    projectCosts: number;
    projectStart?: Date | null;
    projectEnd?: Date | null;
    projectYears: BusinessplanProjectYearEntity[];
}

export interface BusinessplanProjectYearEntity extends BusinessplanYearEntity {
    projectId: string;
    project: BusinessplanProjectEntity;
    amount: number;
}

export interface BusinessplanStaffPlanningEntity {
    id: string;
    businessplanId: string;
    measures: BusinessplanMeasuresEntity;
    function: StaffFunction;
    staffPlanningYears: BusinessplanStaffPlanningYearEntity[];
}

export enum StaffFunction {
    Geschaeftsleitung = 0,
    SGFLeitung = 1,
    Entwicklung = 2,
    Marketing = 3,
    VertriebVerkauf = 4,
    Einkauf = 5,
    Produktion = 6,
    Logistik = 7,
    AfterSales = 8,
    AdministrationITPersonal = 9,
    FinanzRechungswesenControllerdienst = 10,
    Qualitaetsmanagement = 11,
}

export interface BusinessplanStaffPlanningYearEntity extends BusinessplanYearEntity {
    staffPlanningId: string;
    staffPlanning: BusinessplanStaffPlanningEntity;
    count: number;
    salary: number;
}

export interface BusinessplanInfrastructureEntity {
    id: string;
    businessplanId: string;
    measures: BusinessplanMeasuresEntity;
    infrastructureType: InfrastructureType;
    infrastructureYears: BusinessplanInfrastructureYearEntity[];
}

export enum InfrastructureType {
    RentAdditionalCosts = 0,
    LeasingExpenses = 1,
    MaintenanceRepairInstallations = 2,
    CostsForVehicleTransport = 3,
    PropertyInsurance = 4,
    EnergyWasteDisposal = 5,
    AdministrationITCosts = 6,
}

export interface BusinessplanInfrastructureYearEntity extends BusinessplanYearEntity {
    infrastructureId: string;
    infrastructure: BusinessplanInfrastructureEntity;
    amount: number;
}

export interface BusinessplanLiquidityEntity {
    id: string;
    businessplan: BusinessplanEntity;
    months: BusinessplanLiquidityMonthEntity[];
}

export interface BusinessplanLiquidityMonthEntity {
    id: string;
    month: number;
    liquidityId: string;
    liquidity: BusinessplanLiquidityEntity;
    netTurnover: number;
    materialExpenditure: number;
    personnel: number;
    projectsInnovation: number;
    marketing: number;
    rent: number;
    leasing: number;
    maintenanceRepairInstallation: number;
    vehiclesTransport: number;
    propertyInsurance: number;
    energyAndWasteDisposal: number;
    administrationAndIT: number;
    otherOperating: number;
    extraordinaryProfitLoss: number;
    externalProfitLoss: number;
    interest: number;
    financialProfitLoss: number;
    taxes: number;
    dividends: number;
    tangibleAssets: number;
    receivables: number;
    stockAndPendingOrders: number;
    currentLiabilities: number;
    financialAssets: number;
    mortgages: number;
    longTermLoans: number;
    capital: number;
    agio: number;
    shortTermLoans: number;
}

export interface BusinessplanManagementSummaryEntity {
    id: string;
    businessplan: BusinessplanEntity;
    ideaBackground?: string | null;
    visionMarketposition?: string | null;
    legalFormUntilNow: LegalForm;
    hrUntilNow?: Date | null;
    legalFormPlanned: LegalForm;
    hrPlanned?: string | null;
    textListItems: BusinessplanTextListItemEntity[];
    datedListItems: BusinessplanDatedListItemEntity[];
    namedListItems: BusinessplanNamedListItemEntity[];
    achievments: BusinessplanDatedListItemEntity[];
    milestones: BusinessplanDatedListItemEntity[];
    applications: BusinessplanNamedListItemEntity[];
    arguments: BusinessplanNamedListItemEntity[];
    activities: BusinessplanTextListItemEntity[];
    customerBenefits: BusinessplanTextListItemEntity[];
    protectionCompetitors: BusinessplanTextListItemEntity[];
}

export enum LegalForm {
    OneManBusiness = 0,
    Incorporated = 1,
    CollectivCompany = 2,
    LimitedPartnership = 3,
    NoLegalForm = 4,
    EinfacheGesellschaft = 5,
    Genossenschaft = 6,
    Stiftung = 7,
    Kommanditgesellschaft = 8,
    Verein = 9,
}

export interface BusinessplanDatedListItemEntity extends BusinessplanListItemEntity {
    date: Date;
}

export interface BusinessplanNamedListItemEntity extends BusinessplanListItemEntity {
    name: string;
}

export interface BusinessplanAuthorEntity {
    id: string;
    businessplanId: string;
    businessplan: BusinessplanEntity;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
}

export interface BusinessplanProductEntity {
    id: string;
    businessplanId: string;
    businessplan: BusinessplanEntity;
    name: string;
    vat: number;
    skonto: number;
    discount: number;
    productYears: BusinessplanProductYearEntity[];
}

export interface BusinessplanProductYearEntity extends BusinessplanYearEntity {
    productId: string;
    product: BusinessplanProductEntity;
    amount: number;
    price: number;
    material: number;
}

export interface BusinessplanAnalysisYearEntity {
    id: string;
    businessplanId: string;
    businessplan: BusinessplanEntity;
    year: number;
    activeBalance: BusinessplanActiveAnalysisBalanceEntity;
    passiveBalance: BusinessplanPassiveAnalysisBalanceEntity;
    earningsStatement: BusinessplanAnalysisEarningsStatementEntity;
}

export interface BusinessplanActiveAnalysisBalanceEntity {
    liquidAssets: number;
    receivables: number;
    stockAndPendingOrders: number;
    financialAssets: number;
}

export interface BusinessplanPassiveAnalysisBalanceEntity {
    currentLiabilities: number;
    currentAccountBalance: number;
    mortgages: number;
    loans: number;
    capital: number;
    agio: number;
    earningsCarriedForward: number;
}

export interface BusinessplanAnalysisEarningsStatementEntity {
    personnel: number;
    rent: number;
    projectsInnovation: number;
    leasing: number;
    maintenanceRepairInstallation: number;
    vehiclesTransport: number;
    propertyInsurance: number;
    energyAndWasteDisposal: number;
    administrationAndIT: number;
    marketing: number;
    otherOperating: number;
    extraordinaryProfitLoss: number;
    externalProfitLoss: number;
    financialProfitLoss: number;
    dividends: number;
}

export interface BusinessplanPlanYearEntity {
    id: string;
    businessplanId: string;
    businessplan: BusinessplanEntity;
    year: number;
    earningsStatement: BusinessplanPlanEarningsStatementEntity;
    cashFlow: BusinessplanPlanCashFlowEntity;
}

export interface BusinessplanPlanEarningsStatementEntity {
    otherOperating: number;
    extraordinaryProfitLoss: number;
    externalProfitLoss: number;
    financialProfitLoss: number;
    dividends: number;
}

export interface BusinessplanPlanCashFlowEntity {
    financialAssets: number;
    mortgages: number;
    longTermLoans: number;
    capital: number;
    agio: number;
    shortTermLoans: number;
}

export interface BusinessplanInviteEntity {
    id: string;
    salutationId: string;
    email: string;
    firstName: string;
    lastName: string;
    inviterUserId: string;
    inviteConfirmationCode: string;
    inviteConfirmationCodeValidUntil: Date;
    sharedBusinessplanId: string;
    sharedBusinessplan: BusinessplanShareEntity;
    inviterUser: UserEntity;
    fullName: string;
}

export interface SalutationEntity {
    id: string;
    salutationTranslations: SalutationTranslationEntity[];
    users: UserEntity[];
}

export interface SalutationTranslationEntity {
    id: string;
    name: string;
    language: LanguageEntity;
    languageCode: string;
    salutation: SalutationEntity;
    salutationId: string;
}

export interface IdentityUserRoleOfGuid {
    userId: string;
    roleId: string;
}

export interface UserRoleEntity extends IdentityUserRoleOfGuid {
    user: UserEntity;
    role: RoleEntity;
}

export interface RoleEntity extends BaseCreatedModifiedEntity {
    id: string;
    name: string;
    roleRights: RoleRightEntity[];
}

export interface RoleRightEntity extends BaseCreatedModifiedEntity {
    roleId: string;
    role: RoleEntity;
    rightId: string;
    right: RightEntity;
}

export interface RightEntity extends BaseCreatedModifiedEntity {
    id: string;
    key: Rights;
    name: string;
}

export interface BusinessModelCanvasCommentEntity extends BaseCreatedModifiedSavedEntity {
    id: string;
    description: string;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
    businessModelCanvas: BusinessModelCanvasEntity;
}

export interface BusinessModelCanvasSubjectInformationEntity extends BaseCreatedModifiedSavedEntity {
    id: string;
    title: string;
    description?: string | null;
    color: string;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
    businessModelCanvas: BusinessModelCanvasEntity;
}

export interface PagedListModelOfBusinessModelCanvasNoteGridModel {
    items: BusinessModelCanvasNoteGridModel[];
    totalItemCount: number;
}

export interface BusinessModelCanvasNoteGridModel {
    id: string;
    title: string;
    description?: string | null;
    index: number;
    canvasSubject: BusinessModelCanvasSubject;
    canvasSubjectTitleInformation?: string | null;
    businessModelCanvasId: string;
    createUserName: string;
}

export interface BusinessModelCanvasNoteModel {
    id: string;
    title: string;
    description?: string | null;
    color: string;
    index: number;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
    createUserName: string;
    createDate: Date;
    updateUserName: string;
    updateDate?: Date | null;
}

export interface SaveBusinessModelCanvasNoteModel {
    id?: string | null;
    title: string;
    description?: string | null;
    color: string;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
}

export interface BusinessModelCanvasOverviewModel extends IdModel {
    translations: BusinessModelCanvasOverviewTranslationModel[];
}

export interface BusinessModelCanvasOverviewTranslationModel {
    title?: string | null;
    introduction?: string | null;
    languageCode: string;
}

export interface SaveBusinessModelCanvasOverviewModel extends IdModel {
    translations: SaveBusinessModelCanvasOverviewTranslationModel[];
}

export interface SaveBusinessModelCanvasOverviewTranslationModel {
    title?: string | null;
    introduction?: string | null;
    languageCode: string;
}

export interface PagedListModelOfBusinessModelCanvasShareUserModel {
    items: BusinessModelCanvasShareUserModel[];
    totalItemCount: number;
}

export interface BusinessModelCanvasShareFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
}

export interface BusinessModelCanvasIdModel {
    id: string;
    businessModelCanvasId: string;
}

export interface BusinessModelCanvasShareInviteModel extends BusinessModelCanvasIdModel {
    salutationId: string;
    email: string;
    firstName: string;
    lastName: string;
    role: BusinessModelCanvasShareRole;
}

export interface BusinessModelCanvasShareModel {
    id: string;
    businessModelCanvasId: string;
    role: BusinessModelCanvasShareRole;
}

export interface BusinessModelCanvasSubjectInformationModel {
    id: string;
    title: string;
    description?: string | null;
    color: string;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
}

export interface SaveBusinessModelCanvasSubjectInformationModel {
    id?: string | null;
    title: string;
    description?: string | null;
    color: string;
    canvasSubject: BusinessModelCanvasSubject;
    businessModelCanvasId: string;
}

export interface BusinessplanIdModel {
    id: string;
    businessplanId: string;
}

export interface BusinessplanAdditionalInfoModel extends BusinessplanIdModel {
    businessplanPart: BusinessplanPart;
    introText: string;
    annotation: string;
    attachements: BusinessplanBooledListItemModel[];
}

export interface BusinessplanTextListItemModel {
    id: string;
    text: string;
}

export interface BusinessplanBooledListItemModel extends BusinessplanTextListItemModel {
    isChecked: boolean;
}

export interface BusinessplanAnalysisCalculationModel extends BusinessplanIdModel {
    taxRate: number;
    shortIntRate: number;
    longIntRate: number;
    calculationYears: BusinessplanAnalysisCalculationYearModel[];
}

export interface BusinessplanYearModel {
    id: string;
    year: number;
}

export interface BusinessplanAnalysisCalculationYearModel extends BusinessplanYearModel {
    activeBalanceLiquidAssets: number;
    activeBalanceReceivables: number;
    activeBalanceStockAndPendingOrders: number;
    activeBalanceFinancialAssets: number;
    activeBalanceTangibleAssets: number;
    activeBalanceProductionAndMachinery: number;
    activeBalanceEquipment: number;
    activeBalanceITSystems: number;
    activeBalanceVehicles: number;
    activeBalanceRealEstate: number;
    passiveBalanceCurrentLiabilities: number;
    passiveBalanceCurrentAccountBalance: number;
    passiveBalanceMortgages: number;
    passiveBalanceLoans: number;
    passiveBalanceCapital: number;
    passiveBalanceAgio: number;
    passiveBalanceEarningsCarriedForward: number;
    earningsStatementPersonnel: number;
    earningsStatementRent: number;
    earningsStatementProjectsInnovation: number;
    earningsStatementLeasing: number;
    earningsStatementMaintenanceRepairInstallation: number;
    earningsStatementVehiclesTransport: number;
    earningsStatementPropertyInsurance: number;
    earningsStatementEnergyAndWasteDisposal: number;
    earningsStatementAdministrationAndIT: number;
    earningsStatementMarketing: number;
    earningsStatementOtherOperating: number;
    earningsStatementExtraordinaryProfitLoss: number;
    earningsStatementExternalProfitLoss: number;
    earningsStatementFinancialProfitLoss: number;
    earningsStatementDividends: number;
    earningsStatementNetTurnover: number;
    earningsStatementMaterialExpenditure: number;
    earningsStatementGrossProfit: number;
    earningsStatementAmortisationSBAs: number;
}

export interface BusinessplanCompetitorModel extends BusinessplanIdModel {
    name: string;
    postalCode: string;
    city: string;
    description: string;
    employeeCount?: number | null;
    totalRevenue?: number | null;
    products: string;
    services: string;
    strengths: string;
    weaknesses: string;
    expectedStrategy: string;
    expectedMeasures: string;
}

export interface BusinessplanSwotAnalysisModel extends BusinessplanIdModel {
    strengths: BusinessplanTextListItemModel[];
    weaknesses: BusinessplanTextListItemModel[];
    opportunities: BusinessplanTextListItemModel[];
    threats: BusinessplanTextListItemModel[];
    findings: BusinessplanTextListItemModel[];
}

export interface PagedListModelOfBusinessplanListModel {
    items: BusinessplanListModel[];
    totalItemCount: number;
}

export interface BusinessplanListModel {
    id: string;
    name: string;
    type: PlanType;
    firstPlanningYear: number;
    role: BusinessplanShareRole;
    createUserName: string;
    createDate: Date;
    updateUserName: string;
    updateDate?: Date | null;
    language?: string | null;
}

export interface BusinessplanFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
}

export interface GridExportModelOfBusinessplanFilterPagingModel {
    filterPaging: BusinessplanFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface BaseBusinessplanModel {
    type: PlanType;
    name: string;
    currency: Currency;
    numberFormat: NumberFormat;
    firstPlanningYear: number;
    countAnalysisYears?: number | null;
    countPlanningYears?: number | null;
    foundationDate?: Date | null;
    termOfPaymentDebitorsInDays?: number | null;
    termOfPaymentCreditorsInDays?: number | null;
    stockTurnoverInDays?: number | null;
    amountOfIncomeTaxInPercent?: number | null;
    shortDatedInterestOfCreditCapitalAJinPercent?: number | null;
    longDatedInterestOfCreditCapitalAJinPercent?: number | null;
    shortDatedInterestOfCreditCapitalPJinPercent?: number | null;
    longDatedInterestOfCreditCapitalPJinPercent?: number | null;
    languageCode?: string | null;
    address: BusinessplanAddressModel;
    authors: BusinessplanAuthorModel[];
}

export interface BusinessplanModel extends BaseBusinessplanModel {
    id: string;
    logoImage?: FileEntryModel | null;
    frozen: boolean;
    canEdit: boolean;
    businessplanRole: BusinessplanShareRole;
}

export interface BusinessplanAddressModel {
    companyname: string;
    street: string;
    postalCode: string;
    city: string;
    phoneNumber: string;
    homepage: string;
    email: string;
}

export interface BusinessplanAuthorModel {
    id?: string | null;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
}

export interface SaveBusinessplanModel extends BaseBusinessplanModel {
    id?: string | null;
    logoImage?: SaveFileModel | null;
}

export interface BusinessplanInvestmentModel extends BusinessplanIdModel {
    description: string;
    type: InvestmentType;
    amount: number;
    purchaseYear: number;
    usageYears: number;
}

export interface BusinessplanInviteModel {
    firstName: string;
    lastName: string;
    email: string;
}

export interface BusinessplanInviteStatusModel {
    isAccepted: boolean;
    businessplanId: string;
}

export interface BusinessplanManagementSummaryModel extends BusinessplanIdModel {
    ideaBackground?: string | null;
    visionMarketposition?: string | null;
    legalFormUntilNow: LegalForm;
    hrUntilNow?: Date | null;
    legalFormPlanned: LegalForm;
    hrPlanned?: string | null;
    activities: BusinessplanTextListItemModel[];
    customerBenefits: BusinessplanTextListItemModel[];
    protectionCompetitors: BusinessplanTextListItemModel[];
    achievments: BusinessplanDatedListItemModel[];
    milestones: BusinessplanDatedListItemModel[];
    applications: BusinessplanNamedListItemModel[];
    arguments: BusinessplanNamedListItemModel[];
    additionalInfoAchievement: BusinessplanAdditionalInfoModel;
    additionalInfoActivity: BusinessplanAdditionalInfoModel;
    additionalInfoApplication: BusinessplanAdditionalInfoModel;
    additionalInfoArgument: BusinessplanAdditionalInfoModel;
    additionalInfoCustomerBenefit: BusinessplanAdditionalInfoModel;
    additionalInfoIdeaBackground: BusinessplanAdditionalInfoModel;
    additionalInfoLegal: BusinessplanAdditionalInfoModel;
    additionalInfoMilestone: BusinessplanAdditionalInfoModel;
    additionalInfoProtection: BusinessplanAdditionalInfoModel;
    additionalInfoVision: BusinessplanAdditionalInfoModel;
}

export interface BusinessplanDatedListItemModel extends BusinessplanTextListItemModel {
    date: Date;
}

export interface BusinessplanNamedListItemModel extends BusinessplanTextListItemModel {
    name: string;
}

export interface BusinessplanInfrastructureModel extends BusinessplanIdModel {
    infrastructureType: InfrastructureType;
    infrastructureYears: BusinessplanInfrastructureYearModel[];
}

export interface BusinessplanInfrastructureYearModel extends BusinessplanYearModel {
    amount: number;
}

export interface SaveBusinessplanInfrastructureModel extends BusinessplanIdModel {
    infrastructureType: InfrastructureType;
}

export interface BusinessplanMarketingMeasureModel extends BusinessplanIdModel {
    targetGroup: TargetGroup;
    marketingMeasureType: MarketingMeasureType;
    description: string;
    marketingMeasureYears: BusinessplanMarketingMeasureYearModel[];
}

export interface BusinessplanMarketingMeasureYearModel extends BusinessplanYearModel {
    amount: number;
}

export interface SaveBusinessplanMarketingMeasureModel extends BusinessplanIdModel {
    targetGroup: TargetGroup;
    marketingMeasureType: MarketingMeasureType;
    description: string;
}

export interface BusinessplanProjectModel extends BusinessplanIdModel {
    name: string;
    description: string;
    projectCosts: number;
    projectStart?: Date | null;
    projectEnd?: Date | null;
    projectYears: BusinessplanProjectYearModel[];
}

export interface BusinessplanProjectYearModel extends BusinessplanYearModel {
    amount: number;
}

export interface SaveBusinessplanProjectModel extends BusinessplanIdModel {
    name: string;
    description: string;
    projectCosts: number;
    projectStart?: Date | null;
    projectEnd?: Date | null;
}

export interface BusinessplanStaffPlanningModel extends BusinessplanIdModel {
    function: StaffFunction;
    staffPlanningYears: BusinessplanStaffPlanningYearModel[];
}

export interface BusinessplanStaffPlanningYearModel extends BusinessplanYearModel {
    count: number;
    salary: number;
}

export interface SaveBusinessplanStaffPlanningModel extends BusinessplanIdModel {
    function: StaffFunction;
}

export interface BusinessPlanOverviewModel extends IdModel {
    translations: BusinessPlanOverviewTranslationModel[];
}

export interface BusinessPlanOverviewTranslationModel {
    title?: string | null;
    introduction?: string | null;
    description?: string | null;
    languageCode: string;
}

export interface SaveBusinessPlanOverviewModel extends IdModel {
    translations: SaveBusinessPlanOverviewTranslationModel[];
}

export interface SaveBusinessPlanOverviewTranslationModel {
    title?: string | null;
    introduction?: string | null;
    description?: string | null;
    languageCode: string;
}

export interface BusinessplanBalanceAndIncomeModelOfBusinessplanPlanYearBalanceAndIncomeDtoModel extends BusinessplanIdModel {
    taxRate: number;
    analysisTotalCarriedForward: number;
    planYears: BusinessplanPlanYearBalanceAndIncomeDtoModel[];
}

export interface BusinessplanPlanYearBalanceAndIncomeModel extends BusinessplanYearModel {
    earningsStatementOtherOperating: number;
    earningsStatementExtraordinaryProfitLoss: number;
    earningsStatementExternalProfitLoss: number;
    earningsStatementFinancialProfitLoss: number;
    earningsStatementDividends: number;
}

export interface BusinessplanPlanYearBalanceAndIncomeDtoModel extends BusinessplanPlanYearBalanceAndIncomeModel {
    activeBalanceTangibleAssets: number;
    activeBalanceProductionAndMachinery: number;
    activeBalanceEquipment: number;
    activeBalanceITSystems: number;
    activeBalanceVehicles: number;
    activeBalanceRealEstate: number;
    activeBalanceLiquidAssets: number;
    activeBalanceReceivables: number;
    activeBalanceStockAndPendingOrders: number;
    activeBalanceFinancialAssets: number;
    passiveBalanceCurrentLiabilities: number;
    passiveBalanceCurrentAccountBalance: number;
    passiveBalanceMortgages: number;
    passiveBalanceLoans: number;
    passiveBalanceCapital: number;
    passiveBalanceAgio: number;
    earningsStatementPersonnel: number;
    earningsStatementRent: number;
    earningsStatementProjectsInnovation: number;
    earningsStatementLeasing: number;
    earningsStatementMaintenanceRepairInstallation: number;
    earningsStatementVehiclesTransport: number;
    earningsStatementPropertyInsurance: number;
    earningsStatementEnergyAndWasteDisposal: number;
    earningsStatementAdministrationAndIT: number;
    earningsStatementMarketing: number;
    earningsStatementNetTurnover: number;
    earningsStatementMaterialExpenditure: number;
    earningsStatementGrossProfit: number;
    earningsStatementAmortisationSBAs: number;
    earningsStatementInterest: number;
    earningsStatementTaxRate: number;
}

export interface BusinessplanBalanceAndIncomeModelOfBusinessplanPlanYearBalanceAndIncomeModel extends BusinessplanIdModel {
    taxRate: number;
    analysisTotalCarriedForward: number;
    planYears: BusinessplanPlanYearBalanceAndIncomeModel[];
}

export interface BusinessplanCashFlowModelOfBusinessplanPlanYearCashFlowDtoModel extends BusinessplanIdModel {
    planYears: BusinessplanPlanYearCashFlowDtoModel[];
}

export interface BusinessplanPlanYearCashFlowModel extends BusinessplanYearModel {
    financialAssets: number;
    mortgages: number;
    longTermLoans: number;
    capital: number;
    agio: number;
    shortTermLoans: number;
}

export interface BusinessplanPlanYearCashFlowDtoModel extends BusinessplanPlanYearCashFlowModel {
    netTurnover: number;
    expensesGains: number;
    materialExpenditure: number;
    personnel: number;
    projectsInnovation: number;
    rent: number;
    leasing: number;
    maintenanceRepairInstallation: number;
    vehiclesTransport: number;
    propertyInsurance: number;
    energyAndWasteDisposal: number;
    administrationAndIT: number;
    marketing: number;
    otherOperating: number;
    extraordinaryProfitLoss: number;
    externalProfitLoss: number;
    ebitda: number;
    interest: number;
    financialGainLoss: number;
    taxes: number;
    grossCashflow: number;
    receivables: number;
    stockAndPendingOrders: number;
    currentLiabilities: number;
    operativeCashflow: number;
    tangibleAssets: number;
    dividends: number;
    startLiquidity: number;
}

export interface BusinessplanCashFlowModelOfBusinessplanPlanYearCashFlowModel extends BusinessplanIdModel {
    planYears: BusinessplanPlanYearCashFlowModel[];
}

export interface BusinessplanKeyFiguresModel extends BusinessplanYearModel {
    netTurnover: number;
    revenueGrowthRatio: number;
    profitLoss: number;
    level1LiquidityRatio: number;
    level2LiquidityRatio: number;
    level3LiquidityRatio: number;
    netCurrentAssets: number;
    cfbit: number;
    cfbitRevenueRatio: number;
    cashFlowDrain: number;
    equity: number;
    debtEquityRatio: number;
    selfFinancingRatio: number;
    profitLossTurnoverRatio: number;
    returnOnAssetsRatio: number;
    returnOnEquityRatio: number;
    revenuePerEmployee: number;
    totalPersonnel: number;
}

export interface BusinessplanLiquidityModel extends BusinessplanIdModel {
    total: BusinessplanLiquidityTotalModel;
    months: BusinessplanLiquidityMonthModel[];
}

export interface BusinessplanLiquidityMonthModel {
    id: string;
    month: number;
    netTurnover: number;
    materialExpenditure: number;
    personnel: number;
    projectsInnovation: number;
    marketing: number;
    rent: number;
    leasing: number;
    maintenanceRepairInstallation: number;
    vehiclesTransport: number;
    propertyInsurance: number;
    energyAndWasteDisposal: number;
    administrationAndIT: number;
    otherOperating: number;
    extraordinaryProfitLoss: number;
    externalProfitLoss: number;
    interest: number;
    financialProfitLoss: number;
    taxes: number;
    dividends: number;
    tangibleAssets: number;
    receivables: number;
    stockAndPendingOrders: number;
    currentLiabilities: number;
    financialAssets: number;
    mortgages: number;
    longTermLoans: number;
    capital: number;
    agio: number;
    shortTermLoans: number;
}

export interface BusinessplanLiquidityTotalModel extends BusinessplanLiquidityMonthModel {
    startLiquidity: number;
    totalRevenue: number;
    totalExpenses: number;
    totalAssets: number;
    totalInvestments: number;
    totalFinancing: number;
}

export interface BusinessplanValuationOfCompanyModel extends BusinessplanYearModel {
    netAssetValue: number;
    meanValueMethod: number;
    ebt: number;
    value: number;
    multiple: number;
    companyValueEbit: number;
    ebit: number;
    taxes: number;
    amortisations: number;
    investmentCashflow: number;
    totalAssets: number;
    freeCashflow: number;
    eternalRetirementLastYear: number;
    cashValueFreeCashflow: number;
    cashValueEternalRetirement: number;
    cashValueEternalRetirementLastYear: number;
    cashValueFreeCashflowTotal: number;
    cashValueEternalRetirementFirstYear: number;
    grossCompanyValue: number;
    interestDebtCapital: number;
    netCompanyValue: number;
}

export interface BusinessplanValuationOfCompanySettingsModel extends BusinessplanIdModel {
    taxRate: number;
    discountRate: number;
    growth: number;
    multiple: number;
}

export interface BusinessplanProductModel extends BusinessplanIdModel {
    name: string;
    vat: number;
    skonto: number;
    discount: number;
    productYears: BusinessplanProductYearModel[];
}

export interface BusinessplanProductYearModel extends BusinessplanYearModel {
    amount: number;
    price: number;
    material: number;
}

export interface PagedListModelOfBusinessplanShareUserModel {
    items: BusinessplanShareUserModel[];
    totalItemCount: number;
}

export interface BusinessplanShareUserModel {
    id: string;
    email: string;
    fullName: string;
    role: BusinessplanShareRole;
    sharedAt: Date;
    accepted: boolean;
}

export interface BusinessplanShareFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
}

export interface BusinessplanShareInviteModel extends BusinessplanIdModel {
    salutationId: string;
    email: string;
    firstName: string;
    lastName: string;
    role: BusinessplanShareRole;
}

export interface BusinessplanShareModel extends BusinessplanIdModel {
    role: BusinessplanShareRole;
}

export interface BusinessplanStrategyModel extends BusinessplanIdModel {
    customerIntroText?: string | null;
    customerAnnotation?: string | null;
    marketIntroText?: string | null;
    marketAnnotation?: string | null;
    partnerIntroText?: string | null;
    partnerAnnotation?: string | null;
    customers: BusinessplanTextListItemModel[];
    markets: BusinessplanTextListItemModel[];
    partners: BusinessplanTextListItemModel[];
}

export interface SaveBusinessplanTextListItemModel extends BusinessplanIdModel {
    textListItems: BusinessplanTextListItemModel[];
    listItemType: ListItemType;
}

export interface EmailModel {
    id: string;
    template: EmailTemplate;
    translations: EmailTranslationModel[];
}

export enum EmailTemplate {
    UserRegistration = 0,
    ResetPassword = 1,
    NewPassword = 2,
    BusinessplanShareInvitation = 3,
    BusinessModelCanvasShareInvitation = 4,
    BusinessModelCanvasCommentMention = 5,
}

export interface EmailTranslationModel {
    title: string;
    subject: string;
    description: string;
    linkTitle: string;
    additionalInfo: string;
    languageCode: string;
}

export interface PagedListModelOfOverviewEmailModel {
    items: OverviewEmailModel[];
    totalItemCount: number;
}

export interface OverviewEmailModel {
    id: string;
    title?: string | null;
    subject?: string | null;
    editedBy: string;
    lastChange: Date;
}

export interface EmailFilterPagingModel extends FilterPagingModel {
}

export interface HelpTextModel {
    id: string;
    referenceText?: string | null;
    reference: HelpTextCategories;
    placement: HelpTextPlacement;
    author?: string | null;
    displayAuthor: boolean;
    deactivated: boolean;
    translations: HelpTextTranslationModel[];
}

export enum HelpTextCategories {
    BusinessplanOverview = 0,
    BusinessplanBasicInformation = 1,
    BusinessplanFinances = 2,
    BusinessplanParticipants = 3,
    BusinessplanAnalysisCompetitors = 4,
    BusinessplanAnalysisSwot = 5,
    BusinessplanStrategyProducts = 6,
    BusinessplanMarketingMeasures = 7,
    BusinessplanProjects = 8,
    BusinessplanHumanResources = 9,
    BusinessplanInfrastructure = 10,
    BusinessplanAssets = 11,
    BusinessplanBalanceSheet = 12,
    BusinessplanCashFlowForecast = 13,
    BusinessplanLiquidity = 14,
    BusinessplanKeyFigures = 15,
    BusinessplanBusinessValuation = 16,
    BusinessplanManagementSummaryIdea = 17,
    BusinessplanManagementSummaryVision = 18,
    BusinessplanManagementSummaryProducts = 19,
    BusinessplanManagementSummaryCustomerBenefit = 20,
    BusinessplanManagementSummaryProtectability = 21,
    BusinessplanManagementSummaryLegalForm = 22,
    BusinessplanManagementSummaryStatus = 23,
    BusinessplanManagementSummaryMilestones = 24,
    BusinessplanManagementSummaryRequests = 25,
    BusinessplanManagementSummaryArguments = 26,
    BusinessModelCanvasGeneral = 27,
    BusinessModelCanvasParticipants = 28,
    BusinessModelCanvasCreatePdf = 29,
    BusinessModelCanvasKeyPartners = 30,
    BusinessModelCanvasKeyActivities = 31,
    BusinessModelCanvasKeyResources = 32,
    BusinessModelCanvasValuePropositions = 33,
    BusinessModelCanvasCustomerRelationships = 34,
    BusinessModelCanvasChannels = 35,
    BusinessModelCanvasCustomerSegments = 36,
    BusinessModelCanvasCostStructure = 37,
    BusinessModelCanvasRevenueStreams = 38,
}

export enum HelpTextPlacement {
    BusinessPlan = 0,
    BusinessModelCanvas = 1,
    IncorporationService = 2,
    MutationService = 3,
    Blog = 4,
}

export interface HelpTextTranslationModel {
    title: string;
    description: string;
    languageCode: string;
}

export interface PagedListModelOfOverviewHelpTextModel {
    items: OverviewHelpTextModel[];
    totalItemCount: number;
}

export interface OverviewHelpTextModel {
    id: string;
    title?: string | null;
    description?: string | null;
    placement: HelpTextPlacement;
    referenceText: string;
    lastChange: Date;
    editedBy: string;
    deactivated: boolean;
}

export interface HelpTextFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
    placement?: HelpTextPlacement | null;
    includeDeactivated: boolean;
}

export interface IdNameModel extends IdModel {
    name: string;
}

export interface GridExportModelOfHelpTextFilterPagingModel {
    filterPaging: HelpTextFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface HelpTextDeactivatedModel {
    title: string;
    deactivated: boolean;
}

export interface HelpTextViewModel {
    author?: string | null;
    displayAuthor: boolean;
    title: string;
    description: string;
}

export interface InfoTextModel {
    id: string;
    from: Date;
    to: Date;
    deactivated: boolean;
    translations: InfoTextTranslationModel[];
}

export interface InfoTextTranslationModel {
    title: string;
    description: string;
    languageCode: string;
}

export interface InfoTextHomeViewModel {
    id: string;
    title?: string | null;
    description?: string | null;
}

export interface PagedListModelOfOverviewInfoTextModel {
    items: OverviewInfoTextModel[];
    totalItemCount: number;
}

export interface OverviewInfoTextModel {
    id: string;
    title?: string | null;
    description?: string | null;
    from: Date;
    to: Date;
    lastChange: Date;
    editedBy: string;
    deactivated: boolean;
}

export interface InfoTextFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
    includeDeactivated: boolean;
}

export interface SaveInfoTextModel {
    id?: string | null;
    from: Date;
    to: Date;
    deactivated: boolean;
    translations: InfoTextTranslationModel[];
}

export interface GridExportModelOfInfoTextFilterPagingModel {
    filterPaging: InfoTextFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface DocumentsModel {
    id: string;
    termsOfUseChanged: Date;
    dataProcessingAgreementChanged: Date;
    dataProtectionPolicyChanged: Date;
    translations: DocumentsTranslationModel[];
}

export interface DocumentsTranslationModel {
    termsOfUseText: string;
    termsOfUsePdf?: FileEntryModel | null;
    dataProcessingAgreementText: string;
    dataProcessingAgreementPdf?: FileEntryModel | null;
    dataProtectionPolicyText: string;
    dataProtectionPolicyPdf?: FileEntryModel | null;
    imprintText: string;
    imprintPdf?: FileEntryModel | null;
    legalInfoText: string;
    legalInfoPdf?: FileEntryModel | null;
    languageCode: string;
    documents?: DocumentsModel | null;
}

export interface SaveDocumentsModel {
    id?: string | null;
    translations: SaveDocumentsTranslationModel[];
}

export interface SaveDocumentsTranslationModel {
    termsOfUseText: string;
    termsOfUsePdf?: SaveFileModel | null;
    dataProcessingAgreementText: string;
    dataProcessingAgreementPdf?: SaveFileModel | null;
    dataProtectionPolicyText: string;
    dataProtectionPolicyPdf?: SaveFileModel | null;
    imprintText: string;
    imprintPdf?: SaveFileModel | null;
    legalInfoText: string;
    legalInfoPdf?: SaveFileModel | null;
    languageCode: string;
}

export interface HomeModel {
    id: string;
    translations: HomeTranslationModel[];
}

export interface HomeTranslationModel {
    title: string;
    description: string;
    ideaText: string;
    ideaImage?: FileEntryModel | null;
    foundationText: string;
    foundationImage?: FileEntryModel | null;
    growthText: string;
    growthImage?: FileEntryModel | null;
    successionText: string;
    successionImage?: FileEntryModel | null;
    languageCode: string;
}

export interface SaveHomeModel {
    id?: string | null;
    translations: SaveHomeTranslationModel[];
}

export interface SaveHomeTranslationModel {
    title: string;
    description: string;
    ideaText: string;
    ideaImage?: SaveFileModel | null;
    foundationText: string;
    foundationImage?: SaveFileModel | null;
    growthText: string;
    growthImage?: SaveFileModel | null;
    successionText: string;
    successionImage?: SaveFileModel | null;
    languageCode: string;
}

export interface SubpageModel {
    id: string;
    type: Subpages;
    translations: SubpageTranslationModel[];
}

export enum Subpages {
    Idea = 0,
    Foundation = 1,
    Growth = 2,
    Succession = 3,
}

export interface SubpageTranslationModel {
    title: string;
    description: string;
    isFirstActive: boolean;
    firstTitle?: string | null;
    firstText?: string | null;
    firstImage?: FileEntryModel | null;
    isFirstLinkInternal: boolean;
    firstLink?: string | null;
    isSecondActive: boolean;
    secondTitle?: string | null;
    secondText?: string | null;
    secondImage?: FileEntryModel | null;
    isSecondLinkInternal: boolean;
    secondLink?: string | null;
    isThirdActive: boolean;
    thirdTitle?: string | null;
    thirdText?: string | null;
    thirdImage?: FileEntryModel | null;
    isThirdLinkInternal: boolean;
    thirdLink?: string | null;
    isFourthActive: boolean;
    fourthTitle?: string | null;
    fourthText?: string | null;
    fourthImage?: FileEntryModel | null;
    isFourthLinkInternal: boolean;
    fourthLink?: string | null;
    languageCode: string;
}

export interface SaveSubpageModel {
    id?: string | null;
    type: Subpages;
    translations: SaveSubpageTranslationModel[];
}

export interface SaveSubpageTranslationModel {
    title: string;
    description: string;
    isFirstActive: boolean;
    firstTitle?: string | null;
    firstText?: string | null;
    firstImage?: SaveFileModel | null;
    isFirstLinkInternal: boolean;
    firstLink?: string | null;
    isSecondActive: boolean;
    secondTitle?: string | null;
    secondText?: string | null;
    secondImage?: SaveFileModel | null;
    isSecondLinkInternal: boolean;
    secondLink?: string | null;
    isThirdActive: boolean;
    thirdTitle?: string | null;
    thirdText?: string | null;
    thirdImage?: SaveFileModel | null;
    isThirdLinkInternal: boolean;
    thirdLink?: string | null;
    isFourthActive: boolean;
    fourthTitle?: string | null;
    fourthText?: string | null;
    fourthImage?: SaveFileModel | null;
    isFourthLinkInternal: boolean;
    fourthLink?: string | null;
    languageCode: string;
}

export interface IncorporationModel extends IdModel {
    translations: IncorporationTranslationModel[];
}

export interface IncorporationTranslationModel {
    title: string;
    introduction?: string | null;
    description?: string | null;
    image?: FileEntryModel | null;
    languageCode: string;
}

export interface SaveIncorporationModel extends IdModel {
    translations: SaveIncorporationTranslationModel[];
}

export interface SaveIncorporationTranslationModel {
    title: string;
    introduction?: string | null;
    description?: string | null;
    image?: SaveFileModel | null;
    languageCode: string;
}

export interface LanguageModel {
    code: string;
    name: string;
}

export interface EnableAuthenticatorModel {
    sharedKey: string;
    authenticatorUri: string;
    recoveryKeys: string[];
}

export interface AuthenticationCodeModel {
    code?: string | null;
    byRecoveryCode: boolean;
    ipAddress?: string | null;
    browser?: string | null;
    os?: string | null;
    language?: string | null;
}

export interface AuthenticatorKeysModel {
    recoveryKeys: string[];
}

export interface MutationModel extends IdModel {
    translations: MutationTranslationModel[];
}

export interface MutationTranslationModel {
    title: string;
    introduction?: string | null;
    description?: string | null;
    image?: FileEntryModel | null;
    languageCode: string;
}

export interface SaveMutationModel extends IdModel {
    translations: SaveMutationTranslationModel[];
}

export interface SaveMutationTranslationModel {
    title: string;
    introduction?: string | null;
    description?: string | null;
    image?: SaveFileModel | null;
    languageCode: string;
}

export interface SalutationModel {
    id?: string | null;
    name: string;
}

export interface PagedListModelOfTrafficLogModel {
    items: TrafficLogModel[];
    totalItemCount: number;
}

export interface TrafficLogModel {
    ip: string;
    path: string;
    title?: string | null;
    userAgent: string;
    deviceType: string;
    os: string;
    browser: string;
    createdDate: Date;
    pathId?: string | null;
}

export interface TrafficLogFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
}

export interface GridExportModelOfTrafficLogFilterPagingModel {
    filterPaging: TrafficLogFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface ThemeModel {
    fontFamily: string;
    accentPalette: ThemePaletteModel;
    accentContrastPalette: ThemePaletteModel;
    logo: FileEntryModel;
    pwaLogo?: FileEntryModel | null;
}

export interface ThemePaletteModel {
    color50: string;
    color100: string;
    color200: string;
    color300: string;
    color400: string;
    color500: string;
    color600: string;
    color700: string;
    color800: string;
    color900: string;
    colorA100: string;
    colorA200: string;
    colorA400: string;
    colorA700: string;
}

export interface SaveThemeModel {
    fontFamily: string;
    accentPalette: ThemePaletteModel;
    accentContrastPalette: ThemePaletteModel;
    logo?: SaveFileModel | null;
    pwaLogo?: SaveFileModel | null;
}

export interface UserProfileModel {
    id: string;
    firstname: string;
    lastname: string;
    company?: string | null;
    street: string;
    streetNumber: string;
    zip?: number | null;
    city: string;
    email: string;
    phoneNumber?: string | null;
    avatar?: FileModel | null;
    twoFactorEnabled: boolean;
    twoFactorActive: boolean;
}

export interface FileModel {
    id: string;
    type: string;
    name: string;
    isPublic: boolean;
    data: string;
}

export interface UpdateUserProfileModel {
    id?: string | null;
    firstname: string;
    lastname: string;
    company?: string | null;
    street: string;
    streetNumber: string;
    zip?: number | null;
    city: string;
    phoneNumber?: string | null;
    avatar?: SaveFileModel | null;
}

export interface RegisterUserModel {
    id?: string | null;
    salutationId?: string | null;
    firstname: string;
    lastname: string;
    email: string;
    password: string;
    company: string;
    city: string;
    street: string;
    streetNumber: string;
    zip: number;
    phoneNumber?: string | null;
    termsOfUse: boolean;
    dataProcessingAgreement: boolean;
    dataProtectionPolicy: boolean;
    languageCode: string;
}

export interface ResetPasswordModel {
    userName: string;
    verificationToken: string;
}

export interface NewPasswordModel {
    token: string;
    password: string;
    confirmPassword: string;
}

export interface ChangePasswordModel {
    userId: string;
    currentPassword: string;
    password: string;
    passwordConfirmation: string;
}

export interface DeleteMyAccountModel {
    password: string;
}

export interface PagedListModelOfUserModel {
    items: UserModel[];
    totalItemCount: number;
}

export interface BaseUserModel {
    firstname: string;
    lastname: string;
    company?: string | null;
    street: string;
    streetNumber: string;
    zip?: number | null;
    city: string;
    email: string;
    phoneNumber?: string | null;
    businessplanAccess: boolean;
    businessModelCanvasAccess: boolean;
    modules: string;
    termsOfUseAccepted: Date;
    dataProcessingAgreementAccepted: Date;
    dataProtectionPolicyAccepted: Date;
    lastLoginDate?: Date | null;
    createDate?: Date | null;
    emailConfirmed?: boolean | null;
    twoFactorEnabled: boolean;
    twoFactorActive: boolean;
    isSystemUser: boolean;
    isActive: boolean;
    roleIds: string[];
}

export interface UserModel extends BaseUserModel {
    id: string;
    avatar?: FileModel | null;
    roleNames: string[];
    rights: Rights[];
}

export interface UserFilterPagingModel extends FilterPagingModel {
    searchText?: string | null;
    showInactive: boolean;
    showOnlyBusinessModelCanvasModule: boolean;
    showOnlyBusinessplanModule: boolean;
}

export interface GridExportModelOfUserFilterPagingModel {
    filterPaging: UserFilterPagingModel;
    headerMapping: { [key: string]: string; };
}

export interface UserTermsAndPoliciesModel {
    userId: string;
    termsOfUse: boolean;
    dataProcessingAgreement: boolean;
    dataProtectionPolicy: boolean;
    termsOfUseAccepted: boolean;
    dataProcessingAgreementAccepted: boolean;
    dataProtectionPolicyAccepted: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        observer.next(JSON.stringify(blob));
        observer.complete();
    });
}